/* Team K9 direct-response lander runtime. Money truth comes from the Liquid-rendered variant
   JSON (live product object). The buy box is a native Shopify product form, so the Team K9 cart
   intercept owns submission. Fails open: without JS the form still adds the default variant. */
(function () {
  "use strict";

  var root = document.querySelector("[data-tkd]");
  if (!root || root.getAttribute("data-tkd-ready") === "true") return;
  root.setAttribute("data-tkd-ready", "true");

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var landerKey = root.getAttribute("data-tkd-key") || "csce-dtc";
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* Buy 1 / Buy 2 / Buy 3 (2026-10-16, owner: "do that buy 2 offer on our team k9 pages like the couches, doggles").
     Shows a product's EXISTING live quantity price, never a new discount, as one slim row of the page's own option
     tiles above Add to cart. Buy 1 is chosen on load, so a one-item order is still one tap. The totals are what real
     carts charged, per unit price; on a variant whose live price is not in the table the row hides and the page
     works as before. Couch: Kaching deal ddoK (20% / 25% off each), applied through Kaching's line property.
     Goggles: the native automatic discount "Doggles - Buy 2 for $99" (no property needed).
     Record: Pages outputs/team-k9-qty-deal-20261016/HANDOFF.md */
  var QTY_DEALS = {
    "plush-furniture-bed": {
      kaching: { deal: "ddoK", pp: 7666708381795, bids: ["59f49a30-ab9c-4bfa-914e-6ee55ba20df8", "ece26c12-a046-4969-96de-4d6195d5527c", "qOsB"] },
      totals: { 5999: [5999, 9600, 13500], 10999: [10999, 17600, 24750], 11999: [11999, 19200, 27000], 13999: [13999, 22400, 31500], 14999: [14999, 24000, 33750] }
    },
    "dog-goggles": { totals: { 5999: [5999, 9900] } }
  };
  // The row's own classes (not .tkd-size: the couch section reads a pressed .tkd-size as "a size is chosen"), drawn
  // like the page's option tiles. No text under 12 px; the legend is for screen readers only.
  var QTY_CSS = "[data-tkd] .tk9-qty{margin:0;padding:0;border:0;min-width:0}" +
    "[data-tkd] .tk9-qty>legend{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}" +
    "[data-tkd] .tk9-qty-row{display:grid;grid-template-columns:repeat(var(--n,3),minmax(0,1fr));gap:6px;padding-top:9px}" +
    "[data-tkd] .tk9-qty-opt{position:relative;display:grid;justify-items:center;align-content:start;gap:0;margin:0;padding:9px 2px 7px;border:0;border-radius:14px;" +
      "text-align:center;background:#fff;color:var(--ink);font:inherit;box-shadow:inset 0 0 0 1px #28345e33;cursor:pointer;-webkit-appearance:none;appearance:none;transition:box-shadow .2s,background .2s}" +
    "[data-tkd] .tk9-qty-opt[aria-pressed=\"true\"]{background:#f6f2ff;box-shadow:inset 0 0 0 2px var(--purple)}" +
    "[data-tkd] .tk9-qty-opt b{font-size:15px;line-height:1.2;white-space:nowrap}" +
    "[data-tkd] .tk9-qty-each{color:var(--ink);font-size:12.5px;font-weight:700;line-height:1.3;white-space:nowrap}" +
    "[data-tkd] .tk9-qty-off{color:var(--green);font-size:12px;font-style:normal;font-weight:700;line-height:1.25;letter-spacing:-.01em;white-space:nowrap}" +
    "[data-tkd] .tk9-qty-off[hidden]{display:none}" +
    "[data-tkd] .tk9-qty-tag{position:absolute;top:-9px;left:50%;transform:translateX(-50%);padding:0 8px;border-radius:999px;color:#fff;background:var(--purple);" +
      "font-size:12px;font-style:normal;font-weight:800;line-height:1.4;white-space:nowrap}" +
    "@media (max-width:374px){[data-tkd] .tk9-qty-off{white-space:normal;text-wrap:balance}}";
  var qtyDeal = QTY_DEALS[root.getAttribute("data-tkd-product") || ""] || null, qtyIdx = 0, qtyRow = null;
  // Watch counts visits before and after the row apart (page version <key>:<build>-qty1). A direct-response
  // challenger page (2026-10-17) carries data-tkd-dr="b2-dr1" and reports exactly that version, whatever other
  // sections appended to data-tkd-build.
  var drVersion = root.getAttribute("data-tkd-dr");
  if (drVersion) root.setAttribute("data-tkd-build", drVersion);
  else if (qtyDeal) root.setAttribute("data-tkd-build", (root.getAttribute("data-tkd-build") || "b1") + "-qty1");

  function emit(name, detail) {
    var payload = { event: name, tk9_lander: landerKey };
    for (var k in detail || {}) if (Object.prototype.hasOwnProperty.call(detail, k)) payload[k] = detail[k];
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent(name, { detail: payload }));
    } catch (e) { /* analytics never blocks buying */ }
    try { watchOnEvent(name, payload); } catch (e) { /* analytics never blocks buying */ }
  }

  // ------------------------------------------------------------------ Merchanting Watch
  // Names the lander's parts for the Watch recorder (window.MerchantingWatch), so each lander page reports which
  // sections were seen and clicked, which photos were seen, the picks, plays and adds, and the cart and page the
  // shopper arrived from. Ids are generic (tkd.*) so one module compares across landers; the page version
  // (<lander key>:<build>) also separates a lander on a product address from that product's own page.
  // Watch keeps at most 60 facts a page, so wrappers stay unnamed and decorative videos are left out.
  var watchQueue = [], watchTimer = null;
  function watchKey(v) { return String(v || "").toLowerCase().replace(/[^a-z0-9_.:-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 100); }
  function watchFlush() {
    var rec = window.MerchantingWatch;
    if (!rec || typeof rec.track !== "function") return false;
    var retry = [];
    while (watchQueue.length) {
      var q = watchQueue.shift(), ok = true;
      try { ok = rec.track(q.kind, q.details) !== false; } catch (e) { /* drop it */ }
      if (!ok && ++q.tries < 20) retry.push(q);   // false until the recorder's element ledger is ready, or while idle
    }
    watchQueue = retry;
    return !retry.length;
  }
  function watchSend(kind, details) {
    watchQueue.push({ kind: kind, details: details, tries: 0 });
    if (watchQueue.length > 80) watchQueue.shift();
    if (watchFlush() || watchTimer) return;
    watchTimer = setInterval(function () { if (watchFlush()) { clearInterval(watchTimer); watchTimer = null; } }, 1500);
  }
  function watchAct(id, kind, action) { watchSend("element_action", { component_id: watchKey(id), kind: kind, action: action }); }
  function watchName(el, id, kind) {
    if (!el || el.hasAttribute("data-watch-component")) return;
    el.setAttribute("data-watch-component", watchKey(id));
    el.setAttribute("data-watch-kind", kind);
  }
  function watchMarker(id) {   // presence only: lets a Watch report filter visits by component (cart and referrer at entry)
    var m = document.createElement("span");
    m.hidden = true;
    m.style.display = "none";   // an authored display rule on the root's children would beat [hidden]
    watchName(m, id, "copy");
    root.appendChild(m);
  }
  // Runtime events that become Watch actions. Clicks on named parts are counted by the recorder itself.
  function watchOnEvent(name, d) {
    var a = null, film = "tkd.video." + (d.tk9_film || "film");
    if (name === "tk9_dtc_option") a = ["tkd.option." + (d.tk9_option || "choice"), "variant", "change"];
    else if (name === "tk9_dtc_qty") a = ["tkd.option.qty", "variant", "change"];
    else if (name === "tk9_dtc_kit_part") a = ["tkd.kit." + d.tk9_part, "upsell", "change"];
    else if (name === "tk9_dtc_addon") a = ["tkd.addon." + d.tk9_addon, "upsell", "change"];
    // An add that passed the size and patch guards and was handed to the cart (the page cart never reports success).
    else if (name === "tk9_dtc_add_attempt" || name === "tk9_dtc_add_success") a = ["tkd.add", "buy_button", "complete"];
    else if (name === "tk9_dtc_need_size") a = ["tkd.add.need-size", "buy_button", "open"];
    else if (name === "tk9_dtc_need_patch_text") a = ["tkd.add.need-patch-text", "buy_button", "open"];
    else if (name === "tk9_dtc_handoff") a = ["tkd.handoff", "cta", "click"];
    else if (name === "tk9_dtc_to_buy") a = ["tkd.to-buy", "cta", "click"];
    else if (name === "tk9_dtc_problem") a = ["tkd.problem", "cta", "click"];
    else if (name === "tk9_dtc_fit") a = ["tkd.fit", "quiz", "change"];
    else if (name === "tk9_dtc_fit_open") a = ["tkd.fit", "quiz", "open"];
    else if (name === "tk9_dtc_match") a = ["tkd.fit", "quiz", "complete"];
    else if (name === "tk9_dtc_sizeguide") { watchSend("size_guide_opened", { component_id: "tkd.sizeguide" }); a = ["tkd.sizeguide", "size_guide", "open"]; }
    else if (name === "tk9_dtc_film" && d.tk9_on) a = [film, "video", "play"];
    else if (name === "tk9_dtc_film_sound" && d.tk9_on) a = [film, "video", "change"];
    else if (name === "tk9_dtc_clip") a = ["tkd.clips", "video", "play"];
    else if (name === "tk9_dtc_hero_video" && d.tk9_on) a = ["tkd.gallery", "gallery", "play"];
    if (a) watchAct(a[0], a[1], a[2]);
  }
  (function watchMarkup() {
    try {
      root.setAttribute("data-watch-page-version", watchKey(landerKey + ":" + (root.getAttribute("data-tkd-build") || "b1")));
      watchName(root, "lander:" + landerKey, "section");
      root.setAttribute("data-watch-gallery", "");   // every photo of 120 px or more counts, credited to its section
      [[".tkd-gallery", "tkd.gallery", "gallery"], [".tkd-looks", "tkd.looks", "gallery"], [".tkd-parts", "tkd.kit", "upsell"],
       ["[data-tkd-add]", "tkd.add", "buy_button"], [".tkd-lead", "tkd.lead", "headline"], [".tkd-promise", "tkd.promise", "section"],
       [".tkd-tried", "tkd.tried", "section"], [".tkd-steps", "tkd.steps", "section"], [".tkd-timeline", "tkd.timeline", "section"],
       [".tkd-buy", "tkd.buy", "section"], [".tkd-watch", "tkd.clips", "video"], [".tkd-fix", "tkd.mechanism", "section"],
       [".tkd-stories", "tkd.stories", "section"], [".tkd-anatomy", "tkd.anatomy", "section"], [".tkd-compare", "tkd.compare", "comparison"],
       [".tkd-fitguide", "tkd.fit", "quiz"], [".tkd-colors", "tkd.colors", "section"], [".tkd-reviews", "tkd.reviews", "reviews"],
       [".tkd-risk", "tkd.guarantee", "guarantee"], [".tkd-faq", "tkd.faq", "faq"], [".tkd-close", "tkd.close", "section"],
       [".tkd-sticky", "tkd.sticky", "sticky_buy"], [".tkd-modal", "tkd.sizeguide", "size_guide"]
      ].forEach(function (p) { watchName($(p[0]), p[1], p[2]); });
      $$(".tkd-vid, section[data-tkd-film]").forEach(function (sec) {
        var f = sec.matches("[data-tkd-film]") ? sec : $("[data-tkd-film]", sec);
        watchName(sec, "tkd.video." + ((f && f.getAttribute("data-tkd-film")) || "film"), "video");
      });
      $$("[data-tkd-submit]").forEach(function (b) {
        watchName(b, "tkd.add." + (b.closest(".tkd-sticky") ? "sticky" : b.closest(".tkd-close") ? "close" : "more"), "buy_button");
      });
      $$(".tkd-faq details").forEach(function (el, i) { watchName(el, "tkd.faq.q" + (i + 1), "faq"); });
      $$(".tkd-buy details").forEach(function (el, i) { watchName(el, "tkd.buy.acc" + (i + 1), "faq"); });
      $$("details").forEach(function (el) {
        var owner = el.parentElement && el.parentElement.closest("[data-watch-component]");
        watchName(el, (owner && owner !== root ? owner.getAttribute("data-watch-component") : "tkd") + ".details", "faq");
      });
      $$(".tkd-mq").forEach(function (el) { el.setAttribute("data-watch-ignore", ""); });
      $$("section:not([data-watch-ignore])").forEach(function (el) { watchName(el, "tkd.section." + String(el.className).split(" ")[0].replace(/^tkd-/, ""), "section"); });
      // Videos report through the player events above (a muted loop in view is not a play), so the recorder skips them.
      $$("video").forEach(function (v) { v.setAttribute("data-watch-ignore", ""); });
      $$("[data-tkd-film]").forEach(function (f) {
        var fv = $("video", f), id = "tkd.video." + (f.getAttribute("data-tkd-film") || "film"), last = 0, done = false;
        if (!fv) return;
        var finish = function () { if (!done) { done = true; watchAct(id, "video", "complete"); } };
        fv.addEventListener("ended", finish);
        fv.addEventListener("timeupdate", function () {   // the films loop, so a wrap after the last stretch is a finish
          var t = fv.currentTime || 0, dur = fv.duration || 0;
          if (dur && last > dur * 0.85 && t < last - 1) finish();
          last = t;
        });
      });
      // Where the shopper came from inside the store, and what was in the cart when the page opened.
      var ref = null;
      try { ref = document.referrer ? new URL(document.referrer) : null; } catch (e) { ref = null; }
      var rp = ref ? ref.pathname : "";
      watchMarker("tkd.entry.from-" + (!ref ? "direct" : ref.origin !== location.origin ? "outside" : rp === "/" ? "home"
        : /^\/collections/.test(rp) ? "collection" : /^\/products/.test(rp) ? "product" : /^\/pages/.test(rp) ? "page"
        : /^\/blogs/.test(rp) ? "blog" : /^\/search/.test(rp) ? "search" : /^\/cart/.test(rp) ? "cart" : "other"));
      var product = root.getAttribute("data-tkd-product") || "";
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c) return;
          var items = c.items || [], mine = items.some(function (i) { return i.handle === product; });
          watchMarker("tkd.entry.cart-" + (mine ? "this-product" : items.length ? "items" : "empty"));
        })
        .catch(function () { /* no marker when the cart cannot be read */ });
    } catch (e) { /* analytics never blocks buying */ }
  })();

  var data = { variants: [], colorImages: {} };
  try { data = JSON.parse(($("[data-tkd-data]") || {}).textContent || "{}"); } catch (e) { /* keep defaults */ }
  var variants = data.variants || [];
  var form = $("#tkd-form") || $(".tkd-form");
  var idInput = $("[data-tkd-variant-id]");
  var state = [null, null, null];
  var current = null;

  function findVariant(o) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[0] === o[0] && v.options[1] === o[1] && v.options[2] === o[2]) return v;
    }
    return null;
  }
  (function init() {
    var id = idInput ? Number(idInput.value) : 0;
    current = variants.filter(function (v) { return v.id === id; })[0] || variants[0] || null;
    if (current) state = current.options.slice();
  })();

  // Per-product labels come from the section's data block; the fallbacks are the seat cover's (first lander).
  var sizeLabels = data.sizeLabels || null, colorKeys = data.colorKeys || null, colorLabels = data.colorLabels || {};
  var setupNames = data.setupNames || null;
  // Products where a default size would be a guess (harnesses) hold the add until the shopper picks one.
  var requireSize = !!data.requireSize, sizeChosen = false;
  function needSize() { return requireSize && !sizeChosen; }
  function sizeName(v) { return sizeLabels ? (sizeLabels[v] || v || "") : (/extra/i.test(v || "") ? "Extra-Large" : "Large"); }
  function colorName(v) { return colorLabels[v] || v || ""; }
  function savePct(v) { return v.compare > v.price ? Math.floor((v.compare - v.price) * 100 / v.compare) : 0; }
  function colorKey(c) { if (colorKeys) return colorKeys[c] || ""; c = String(c || "").toLowerCase(); return /gr[ae]y/.test(c) ? "gray" : /beige|tan|cream/.test(c) ? "beige" : "black"; }
  function text(sel, value) { $$(sel).forEach(function (n) { n.textContent = value; }); }
  // Format a cents amount using the shop's own rendered price as the pattern (keeps symbol and separators).
  function money(cents, sample) {
    var num = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return String(sample || "$0.00").replace(/[\d.,]+/, num);
  }
  // Whole-dollar savings from live compare-at pricing ("$190"), in the shop's own money pattern.
  function saveDollars(v) {
    if (!v || !(v.compare > v.price)) return "";
    return money(Math.floor((v.compare - v.price) / 100) * 100, v.price_fmt).replace(/[.,]00$/, "");
  }
  // Optional add-ons: separate live products, each added as its own cart line.
  var addons = (data.addons || []).map(function (a) { return { id: a.id, price: a.price, name: a.name, on: false, added: false }; });
  function addonTotal() { return addons.reduce(function (sum, a) { return sum + (a.on ? a.price : 0); }, 0); }
  function pendingAddons() { return addons.filter(function (a) { return a.on && !a.added; }); }

  /* custom name patch: a separate product whose size follows the harness size and whose printed text travels as
     line item properties (the names the store's fulfillment reads) */
  var namePatch = $("[data-tkd-namepatch]"), npItem = null;
  function npText() {
    var n = $("[data-tkd-namepatch-name]", namePatch), p = $("[data-tkd-namepatch-phone]", namePatch);
    return { name: n ? n.value.trim().slice(0, 18) : "", phone: p ? p.value.trim().slice(0, 18) : "" };
  }
  function needPatchText() { if (!npItem || !npItem.on) return false; var t = npText(); return !t.name && !t.phone; }
  if (namePatch) {
    npItem = { id: "namepatch", price: Number(namePatch.getAttribute("data-price") || 0), name: namePatch.getAttribute("data-name") || "Name patches", on: false, added: false,
      variantId: function () {
        var small = (namePatch.getAttribute("data-small-sizes") || "").split(",");
        var btn = $$('[data-tkd-choice="1"]').filter(function (b) { return b.getAttribute("data-value") === state[1]; })[0];
        var key = btn ? btn.getAttribute("data-size") : "";
        return Number(namePatch.getAttribute(small.indexOf(key) > -1 ? "data-small-id" : "data-large-id"));
      },
      props: function () {
        var t = npText(), out = { _tk9_lander: landerKey + ":addon" };
        if (t.name) out[namePatch.getAttribute("data-prop-name")] = t.name;
        if (t.phone) out[namePatch.getAttribute("data-prop-phone")] = t.phone;
        return out;
      } };
    addons.push(npItem);
  }

  /* Build-your-kit parts that are their own products (a waste bag pouch, a car belt): each is a separate cart line.
     Every part also carries its own variants, so its tile photo follows the chosen harness color. */
  var partData = data.parts || {}, lineItems = {};
  function partVariant(key) {      // the part's variant for the chosen color: its pick, then color, then fallback color
    var pd = partData[key]; if (!pd || !pd.variants || !pd.variants.length) return null;
    var pool = pd.variants.filter(function (x) { for (var i in (pd.pick || {})) if (x.o[Number(i)] !== pd.pick[i]) return false; return true; });
    if (!pool.length) pool = pd.variants;
    var live = pool.filter(function (x) { return x.available; });
    if (live.length) pool = live;
    return pool.filter(function (x) { return x.o[0] === state[0]; })[0] || pool.filter(function (x) { return x.o[0] === pd.fallback; })[0] || pool[0];
  }
  if (data.builder) {
    data.builder.parts.forEach(function (key) {
      var pd = partData[key]; if (!pd || !pd.line || !pd.variants || !pd.variants.length) return;
      lineItems[key] = { id: "part:" + key, part: key, price: 0, name: pd.name, on: false, added: false, vid: null,
        variantId: function () { var pv = partVariant(key); return pv ? pv.id : null; },
        props: function () { return { _tk9_lander: landerKey + ":addon" }; } };
      addons.push(lineItems[key]);
    });
  }

  /* =================== gallery =================== */
  var mainImg = $(".tkd-gallery-img");
  var heroThumb = $("[data-tkd-thumb][data-hero]");
  function showImage(src) {
    if (!mainImg || !src || mainImg.getAttribute("data-src") === src) return;
    mainImg.setAttribute("data-src", src);
    mainImg.classList.add("is-swapping");
    var next = new Image();
    next.onload = next.onerror = function () {
      if (mainImg.getAttribute("data-src") !== src) return;   // a newer picture was asked for while this one loaded
      mainImg.removeAttribute("srcset");
      mainImg.src = src;
      mainImg.classList.remove("is-swapping");
    };
    next.src = src;
  }
  $$("[data-tkd-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      $$("[data-tkd-thumb]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === t)); });
      showImage(t.getAttribute("data-src"));
      emit("tk9_dtc_gallery", {});
    });
  });

  /* Small pictures near the top (photo swatches) wait until the hero poster has painted, so they never compete with
     the largest paint on a phone. Until then each swatch shows its flat color. */
  var deferredDone = false;
  function loadDeferred() {
    if (deferredDone) return; deferredDone = true;
    $$("[data-tkd-defer-src]").forEach(function (img) { img.src = img.getAttribute("data-tkd-defer-src"); img.removeAttribute("data-tkd-defer-src"); });
  }
  if (document.readyState === "complete") setTimeout(loadDeferred, 0); else window.addEventListener("load", loadDeferred);
  setTimeout(loadDeferred, 3500);

  /* =================== hero video (customer review montage) =================== */
  var hero = $("[data-tkd-hero]"), heroVideo = $("[data-tkd-hero-video]"), heroToggle = $("[data-tkd-hero-toggle]");
  var heroWanted = false, heroSeen = true;
  var heroLoaded = !!(heroVideo && heroVideo.getAttribute("src"));
  var conn = navigator.connection || {};
  var lean = reduceMotion || !!conn.saveData || /(^|-)2g|3g/.test(conn.effectiveType || "");
  function heroState(on) {
    if (!hero) return;
    hero.setAttribute("data-video", on ? "on" : "off");
    if (heroToggle) {
      heroToggle.setAttribute("aria-pressed", String(on));
      var noun = hero.getAttribute("data-video-noun") || "customer videos";
      heroToggle.setAttribute("aria-label", (on ? "Pause " : "Play ") + noun);
    }
  }
  function playHeroVideo() {
    if (!heroVideo) return;
    if (!heroLoaded) {
      // phones get the lighter file
      var small = heroVideo.getAttribute("data-src-sm");
      heroVideo.src = small && window.matchMedia && window.matchMedia("(max-width: 749px)").matches ? small : heroVideo.getAttribute("data-src");
      heroLoaded = true;
    }
    heroVideo.muted = true;
    var p = heroVideo.play();
    if (p && typeof p.catch === "function") p.catch(function () { heroState(false); });
  }
  function stopHeroVideo() {
    heroWanted = false;
    if (heroVideo && heroLoaded) heroVideo.pause();
    heroState(false);
  }
  if (hero && heroVideo && (heroLoaded || heroVideo.getAttribute("data-src"))) {
    heroVideo.addEventListener("playing", function () { heroState(true); });
    heroVideo.addEventListener("pause", function () { heroState(false); });
    heroVideo.addEventListener("error", function () { heroState(false); });
    if (heroToggle) {
      heroToggle.hidden = false;
      heroToggle.addEventListener("click", function () {
        var on = hero.getAttribute("data-video") === "on";
        if (on) stopHeroVideo(); else { heroWanted = true; playHeroVideo(); }
        emit("tk9_dtc_hero_video", { tk9_on: !on });
      });
    }
    if (lean) heroState(false);
    else {
      heroWanted = true;
      // Let the poster (the largest paint) arrive first; the video download starts right after it.
      var heroStarted = false;
      var startHero = function () { if (heroStarted) return; heroStarted = true; loadDeferred(); if (heroWanted && heroSeen) playHeroVideo(); };
      var posterSrc = heroVideo.getAttribute("poster");
      if (posterSrc) {
        var posterImg = new Image();
        posterImg.onload = posterImg.onerror = startHero;
        posterImg.src = posterSrc;
        if (posterImg.complete) startHero();
        setTimeout(startHero, 3000);
      } else startHero();
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        heroSeen = entries[0].isIntersecting;
        if (!heroLoaded) return;
        if (!heroSeen) heroVideo.pause();
        else if (heroWanted) playHeroVideo();
      }, { threshold: 0.25 }).observe(hero);
    }
  }

  /* =================== variant render =================== */
  // Products with more variants than Liquid can list (250) embed only the default color's rows; the rest of the
  // table comes from the product's own JSON, as the product page does.
  var tableComplete = !(data.variants_expected > variants.length), tableLoading = false, tableFailed = false;
  function rowToVariant(r) {
    return { id: r[0], options: [r[1] || null, r[2] || null, r[3] || null], price: r[4], compare: r[5] || 0, available: !!r[6], price_fmt: r[7], compare_fmt: r[8], image: r[9] || null };
  }
  // One page (250 rows) of the product's variants from the tk9-dtc-variant-table section, rendered by Shopify for the
  // product URL. Liquid loops and /products/<handle>.js both stop at 250 variants; this pages past that.
  function tablePage(n) {
    return fetch(data.variant_table + "&page=" + n, { headers: { Accept: "text/html" } }).then(function (r) { return r.ok ? r.text() : ""; }).then(function (html) {
      var m = html.match(/<script[^>]*data-tkd-variant-page[^>]*>([\s\S]*?)<\/script>/);
      return m ? JSON.parse(m[1]) : null;
    }).catch(function () { return null; });
  }
  function tableFromSection() {
    if (!data.variant_table) return Promise.resolve(null);
    return tablePage(1).then(function (first) {
      if (!first || !first.variants) return null;
      var rest = [];
      for (var i = 2; i <= Math.min(first.pages || 1, 8); i++) rest.push(tablePage(i));
      return Promise.all(rest).then(function (more) {
        var rows = first.variants;
        more.forEach(function (p) { if (p && p.variants) rows = rows.concat(p.variants); });
        return rows.map(rowToVariant);
      });
    });
  }
  function tableFromProductJs() {
    if (!data.product_js) return Promise.resolve(null);
    var sample = (variants[0] || {}).price_fmt || "$0.00";
    return fetch(data.product_js, { headers: { Accept: "application/json" } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d || !d.variants || !d.variants.length) return null;
      return d.variants.map(function (x) {
        var img = x.featured_image && x.featured_image.src ? x.featured_image.src : "";
        return {
          id: x.id, options: [x.option1 || null, x.option2 || null, x.option3 || null], available: !!x.available,
          price: x.price, price_fmt: money(x.price, sample), compare: x.compare_at_price || 0, compare_fmt: money(x.compare_at_price || 0, sample),
          image: img ? img + (img.indexOf("?") > -1 ? "&" : "?") + "width=240" : null
        };
      });
    }).catch(function () { return null; });
  }
  function loadTable() {
    if (tableComplete || tableLoading) return;
    tableLoading = true;
    var want = data.variants_expected || 0;
    tableFromSection().then(function (rows) {
      if (rows && rows.length >= want) return rows;
      return tableFromProductJs().then(function (js) { return js && (!rows || js.length > rows.length) ? js : rows; });
    }).then(function (rows) {
      if (rows && rows.length > variants.length) variants = rows;   // never trade the embedded rows for fewer
      tableComplete = !(want > variants.length);
      tableFailed = !tableComplete;                                  // still short: unknown combinations hand off to the product page
      tableLoading = false;
      root.removeAttribute("data-tkd-pending");
      render();
    });
  }
  /* ---- build your kit: which variant, and which parts as their own cart lines ---- */
  function kitParts() {            // parts inside the chosen kit variant; null for a bundle outside the map
    for (var k in data.builder.map) if (data.builder.map[k] === state[2]) return k ? k.split("+") : [];
    return null;
  }
  function kitKey(list) { return data.builder.parts.filter(function (p) { return list.indexOf(p) > -1; }).join("+"); }
  function selParts() {
    var kp = kitParts();
    if (kp === null) return data.builder.parts.slice();   // a bundle outside the map holds every part
    return data.builder.parts.filter(function (p) { return kp.indexOf(p) > -1 || (lineItems[p] && lineItems[p].on); });
  }
  // The cheapest way to buy a set of parts. Parts the store sells inside one kit variant go in the variant; a part that
  // is its own product is added as its own line unless a kit variant that holds it costs less. Null while the variant
  // rows for this color are still loading, or when the set cannot be bought.
  function resolveKit(list) {
    var must = [], opt = [], best = null;
    list.forEach(function (p) { (lineItems[p] ? opt : must).push(p); });
    var baseV = findVariant([state[0], state[1], data.builder.map[kitKey(must)]]);
    for (var m = (1 << opt.length) - 1; m >= 0; m--) {
      var inKit = must.slice(), lines = [];
      opt.forEach(function (p, i) { (m & (1 << i) ? inKit : lines).push(p); });
      var value = data.builder.map[kitKey(inKit)]; if (!value) continue;
      var kv = findVariant([state[0], state[1], value]); if (!kv) continue;
      // Adding a part must never lower the "was" price. A kit variant whose compare-at is below the same kit without
      // the part is mispriced in the store, so it is passed over and the part is sold as its own line instead.
      if (inKit.length > must.length && baseV && Math.max(kv.compare || 0, kv.price) < Math.max(baseV.compare || 0, baseV.price)) continue;
      var price = kv.price, was = Math.max(kv.compare || 0, kv.price), ok = true;
      lines.forEach(function (p) { var pv = partVariant(p); if (!pv || !pv.available) ok = false; else { price += pv.price; was += Math.max(pv.compare || 0, pv.price); } });
      if (ok && (!best || price < best.price)) best = { value: value, lines: lines, price: price, was: was };
    }
    return best;
  }
  function setLines(list) {
    for (var k in lineItems) { var on = list.indexOf(k) > -1; if (lineItems[k].on !== on) { lineItems[k].on = on; lineItems[k].added = false; } }
  }

  var handoff = false, appliedColor = null, lastKit = null;
  function render(changedIdx) {
    if (data.builder) {
      // line parts take the price and variant of the chosen color; the kit and the lines settle into their cheapest split
      for (var lk in lineItems) {
        var lpv = partVariant(lk), lit = lineItems[lk];
        lit.price = lpv ? lpv.price : 0;
        if (lit.vid !== (lpv ? lpv.id : null)) { lit.vid = lpv ? lpv.id : null; lit.added = false; }
      }
      if (kitParts() === null) setLines([]);
      else { var fit = resolveKit(selParts()); if (fit) { state[2] = fit.value; setLines(fit.lines); } }
    }
    var v = findVariant(state);
    handoff = false;
    if (!v && !tableComplete) {
      // the shopper picked a combination we have no row for yet: show the choice and hold the button while it loads.
      // If the table could not be completed, send this choice to the product page instead of guessing a variant.
      if (!tableFailed) loadTable();
      handoff = tableFailed;
      if (handoff) root.removeAttribute("data-tkd-pending"); else root.setAttribute("data-tkd-pending", "true");
      $$("[data-tkd-choice]").forEach(function (b) {
        b.setAttribute("aria-pressed", String(state[Number(b.getAttribute("data-tkd-choice"))] === b.getAttribute("data-value")));
      });
      var pendingAdd = $("[data-tkd-add]"), pendingLabel = $("[data-tkd-add-label]");
      if (pendingAdd) pendingAdd.disabled = !handoff;
      if (pendingLabel) pendingLabel.textContent = handoff ? "Choose this option on the product page" : "Loading…";
      return;
    }
    if (!v) {
      v = variants.filter(function (x) { return x.options[0] === state[0] && x.options[1] === state[1]; })[0] ||
          variants.filter(function (x) { return x.options[0] === state[0]; })[0] || variants[0];
      if (v) state = v.options.slice();
    }
    if (!v) return;
    current = v;
    if (idInput && idInput.value !== String(v.id)) {
      idInput.value = v.id;
      // lets Shopify's payment-terms banner recalculate installments for the new variant
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    $$("[data-tkd-choice]").forEach(function (b) {
      var idx = Number(b.getAttribute("data-tkd-choice")), val = b.getAttribute("data-value");
      b.setAttribute("aria-pressed", String(state[idx] === val && !(idx === 1 && needSize())));
      var probe = state.slice(); probe[idx] = val;
      var pv = findVariant(probe);
      b.setAttribute("data-unavailable", String(tableComplete ? (!pv || !pv.available) : !!(pv && !pv.available)));
    });
    $$("[data-tkd-opt-label]").forEach(function (n) {
      var idx = Number(n.getAttribute("data-tkd-opt-label"));
      n.textContent = idx === 1 ? (needSize() ? "choose one" : sizeName(state[1])) : idx === 0 ? colorName(state[0]) : state[idx];
      if (idx === 1 && !needSize()) n.classList.remove("is-needed");
    });
    $$("[data-tkd-setup-price]").forEach(function (n) {
      var pv = findVariant([state[0], state[1], n.getAttribute("data-tkd-setup-price")]);
      n.textContent = pv ? pv.price_fmt : "";
    });
    $$("[data-tkd-setup-compare]").forEach(function (n) {
      var pv = findVariant([state[0], state[1], n.getAttribute("data-tkd-setup-compare")]);
      n.textContent = pv && pv.compare > pv.price ? pv.compare_fmt : "";
    });
    $$("[data-tkd-setup-save]").forEach(function (n) {
      var amt = saveDollars(findVariant([state[0], state[1], n.getAttribute("data-tkd-setup-save")]));
      n.textContent = amt ? "Save " + amt : "";
    });
    $$("[data-tkd-setup-img]").forEach(function (n) {
      var pv = findVariant([state[0], state[1], n.getAttribute("data-tkd-setup-img")]);
      // larger placements (tiles, stories, anatomy) carry data-w; the table stores a 240px thumbnail
      var w = n.getAttribute("data-w"), src = pv && pv.image ? (w ? pv.image.replace(/width=\d+/, "width=" + w) : pv.image) : "";
      if (src && n.getAttribute("src") !== src) n.src = src;
    });

    if (data.builder) {
      var have = selParts();
      $$("[data-tkd-part]").forEach(function (b) {
        var part = b.getAttribute("data-tkd-part"), on = have.indexOf(part) > -1;
        b.setAttribute("aria-pressed", String(on));
        var others = have.filter(function (p) { return p !== part; });
        // A kit part is priced on the kit alone, so its price holds still whatever else is ticked. A part that is its
        // own product shows what it adds right now (less when a kit that holds it is the cheaper way to buy it).
        var basis = lineItems[part] ? others : others.filter(function (p) { return !lineItems[p]; });
        var withR = resolveKit(basis.concat([part])), withoutR = resolveKit(basis);
        var pe = $('[data-tkd-part-price="' + part + '"]'), se = $('[data-tkd-part-save="' + part + '"]');
        if (withR && withoutR) {
          var add = withR.price - withoutR.price, was = withR.was - withoutR.was;
          if (pe) pe.textContent = "+" + money(add, v.price_fmt);
          if (se) se.textContent = was > add ? "Save " + money(Math.floor((was - add) / 100) * 100, v.price_fmt).replace(/[.,]00$/, "") : "";
        }
        b.setAttribute("data-unavailable", String(tableComplete && !resolveKit(others.concat([part]))));
        // the tile shows the part in the chosen color (or says which color it comes in)
        var pv = partVariant(part), img = b.querySelector("[data-tkd-part-img]");
        if (img && pv && pv.image && img.getAttribute("src") !== pv.image) img.src = pv.image;
        b.setAttribute("data-other-color", String(!!(pv && pv.o[0] && pv.o[0] !== "Default Title" && pv.o[0] !== state[0])));
        if (b.hasAttribute("data-tkd-part-line")) b.setAttribute("data-line-variant", lineItems[part] && lineItems[part].on && pv ? String(pv.id) : "");
      });
      $$("[data-tkd-part-tpl][data-template]").forEach(function (n) {
        var tv = partVariant(n.getAttribute("data-tkd-part-tpl"));
        n.textContent = n.getAttribute("data-template").replace("{color}", tv ? colorName(tv.o[0]) : "");
      });
      for (var rk in lineItems) {
        var rpv = partVariant(rk), rshow = !!(rpv && rpv.compare > rpv.price);
        text('[data-tkd-part-stack-price="' + rk + '"]', rpv ? money(rpv.price, v.price_fmt) : "");
        $$('[data-tkd-part-stack-compare="' + rk + '"]').forEach(function (n) { n.hidden = !rshow; n.textContent = rshow ? money(rpv.compare, v.price_fmt) : ""; });
      }
      $$("[data-tkd-bundle]").forEach(function (bb) {
        var set = bb.getAttribute("data-tkd-bundle").split("+"), br = resolveKit(set), small = bb.querySelector("[data-tkd-bundle-price]");
        if (small) small.textContent = br ? money(br.price, v.price_fmt) : "";
        bb.setAttribute("aria-pressed", String(have.length === set.length && set.every(function (p) { return have.indexOf(p) > -1; })));
      });
      // The hero photo follows the kit and the color once the shopper changes either. It shows the kit photo for the
      // ticked parts even when a part is its own cart line; parts no kit photo shows (the belt) are left out.
      var dkParts = have.slice(), dkOrder = data.builder.parts.filter(function (p) { return lineItems[p]; }).reverse();
      var dk = findVariant([state[0], state[1], data.builder.map[kitKey(dkParts)]]);
      for (var di = 0; !dk && di < dkOrder.length; di++) {
        dkParts = dkParts.filter(function (p) { return p !== dkOrder[di]; });
        dk = findVariant([state[0], state[1], data.builder.map[kitKey(dkParts)]]);
      }
      if (!dk) dk = v;
      var kitSig = state[0] + "|" + have.join("+");
      // A color pick shows that color in use (data.colorScenes) when the page has such pictures; a kit change shows the kit photo.
      var scene = changedIdx === 0 && data.colorScenes ? data.colorScenes[colorKey(state[0])] : null;
      if ((changedIdx === 0 || changedIdx === 2) && (scene || dk.image) && lastKit !== null && lastKit !== kitSig) {
        $$("[data-tkd-thumb]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === heroThumb)); });
        stopHeroVideo();
        showImage(scene || dk.image.replace(/width=\d+/, "width=1100"));
      }
      lastKit = kitSig;
    }

    text("[data-tkd-price]", v.price_fmt);
    text("[data-tkd-final-price]", v.price_fmt);
    text("[data-tkd-sticky-price]", v.price_fmt);
    var pct = savePct(v);
    $$("[data-tkd-compare], [data-tkd-final-compare]").forEach(function (n) { n.hidden = !pct; n.textContent = v.compare_fmt; });
    $$("[data-tkd-save]").forEach(function (n) { n.hidden = !pct; n.textContent = "Save " + pct + "%"; });

    var hints = data.colorHints || { black: "hides mess", gray: "hides hair", beige: "matches tan interiors" };
    var hint = hints[colorKey(state[0])] || "";
    text("[data-tkd-color-hint]", hint ? "· " + hint : "");
    var title = colorName(state[0]) + (needSize() ? "" : " · " + sizeName(state[1]));
    if (!needSize()) { var sizeErr = $("[data-tkd-error]"); if (sizeErr && sizeErr.getAttribute("data-kind") === "size") { sizeErr.hidden = true; sizeErr.removeAttribute("data-kind"); } }
    var setupName = setupNames ? (setupNames[state[2]] || {}) : null;
    text("[data-tkd-sticky-title]", title);
    text("[data-tkd-sel-title]", title);
    var selText = setupName ? (setupName.sel || "") : (/bed/i.test(state[2] || "") ? "with Plush Backseat Bed" : "with FREE safety belt");
    for (var sk in lineItems) if (lineItems[sk].on) selText = selText.replace(/ only$/, "") + " + " + (partData[sk].sel || lineItems[sk].name.toLowerCase());
    text("[data-tkd-sel-setup]", selText);

    var total = v.price + addonTotal();
    var totalFmt = money(total, v.price_fmt);
    var add = $("[data-tkd-add]"), label = $("[data-tkd-add-label]");
    if (add) add.disabled = !v.available;
    if (label) label.textContent = v.available ? "Add to cart · " + totalFmt : "Sold out";
    text("[data-tkd-sticky-price]", totalFmt);
    text("[data-tkd-stack-name]", setupName ? (setupName.stack || state[2] || "") : (/bed/i.test(state[2] || "") ? "Hard Bottom Seat Cover + Plush Backseat Bed" : "Hard Bottom Seat Cover"));
    $$("[data-tkd-shipnote]").forEach(function (n) {
      // free-shipping threshold lines: data-free-over is in cents, read from the section
      var over = Number(n.getAttribute("data-free-over") || 0);
      n.setAttribute("data-free", String(!over || total >= over));
    });
    $$("[data-tkd-ship-nudge]").forEach(function (n) {
      var over = Number(n.getAttribute("data-free-over") || 0), gap = over - total;
      n.hidden = !(over && gap > 0);
      var g = n.querySelector("[data-tkd-ship-gap]");
      if (g && gap > 0) g.textContent = money(gap, v.price_fmt);
    });
    text("[data-tkd-stack-variant]", title);
    text("[data-tkd-stack-price]", v.price_fmt);
    $$("[data-tkd-stack-compare]").forEach(function (n) { n.hidden = !pct; n.textContent = v.compare_fmt; });
    $$("[data-tkd-stack-addon]").forEach(function (n) {
      var id = n.getAttribute("data-tkd-stack-addon");
      n.hidden = !addons.some(function (a) { return a.on && String(a.id) === id; });
    });
    text("[data-tkd-stack-total]", totalFmt);
    $$('[data-tkd-submit="final"]').forEach(function (b) { b.textContent = needSize() ? "Choose your size" : v.available ? "Add to cart · " + totalFmt : "See other options"; });
    text("[data-tkd-final-total]", totalFmt);
    $$("[data-tkd-final-save]").forEach(function (n) { var amt = saveDollars(v); n.hidden = !amt; n.textContent = amt ? "You save " + amt : ""; });
    qtyRender(v);
    refreshSticky();

    // Follows the chosen color whenever it differs from what is showing (a color picked while the variant table was
    // still loading is applied by the render that follows the load, which carries no changed index).
    var ck0 = colorKey(state[0]);
    if (appliedColor === null) appliedColor = ck0;
    if (appliedColor !== ck0 && !(data.colorImages || {})[ck0]) {
      appliedColor = ck0;
      $$("[data-tkd-cimg]").forEach(function (img) {
        if (!img.getAttribute("data-base")) img.setAttribute("data-base", img.getAttribute("src"));
        var next = img.getAttribute("data-" + ck0) || img.getAttribute("data-base");
        if (!next || img.getAttribute("src") === next) return;
        img.removeAttribute("srcset");
        img.src = next;
      });
    }
    if (changedIdx === 0 || changedIdx === undefined) {
      var src = (data.colorImages || {})[colorKey(state[0])];
      if (src) {
        if (heroThumb) {
          heroThumb.setAttribute("data-src", src);
          var ti = heroThumb.querySelector("img");
          if (ti) { ti.removeAttribute("srcset"); ti.src = src.replace(/width=\d+/, "width=160"); }
        }
        if (changedIdx === 0) {
          var ckey = colorKey(state[0]);
          $$("[data-tkd-cimg]").forEach(function (img) {
            var next = img.getAttribute("data-" + ckey);
            if (!next || img.getAttribute("src") === next) return;
            img.removeAttribute("srcset");
            img.src = next;
          });
          $$("[data-tkd-thumb]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === heroThumb)); });
          stopHeroVideo();
          showImage(src);
          var wallEl = $("[data-tkd-wall]");
          if (wallEl && wallEl.scrollLeft > 0) wallEl.scrollTo({ left: 0, behavior: "instant" });
        }
        var fi = $(".tkd-final-img");
        if (fi) { fi.removeAttribute("srcset"); fi.src = src.replace(/width=\d+/, "width=640"); }
      }
    }
  }

  function select(idx, value, source) {
    if (idx === 1 && !sizeChosen && state[1] === value) watchAct("tkd.option.size", "variant", "change");   // confirming the shown size is a pick too
    if (idx === 1) { sizeChosen = true; refreshSticky(); }
    if (state[idx] !== value) {
      state[idx] = value;
      emit("tk9_dtc_option", { tk9_option: ["color", "size", "setup"][idx], tk9_value: value, tk9_source: source || "buybox" });
    }
    render(idx);
  }
  $$("[data-tkd-choice]").forEach(function (b) {
    b.addEventListener("click", function () { select(Number(b.getAttribute("data-tkd-choice")), b.getAttribute("data-value")); });
  });
  if (variants.length) render();
  if (!tableComplete) { if (document.readyState === "complete") loadTable(); else window.addEventListener("load", loadTable); }

  /* =================== fit check =================== */
  var PICKUP = /\b(pick ?-?up|truck|crew ?cab|ext(ended)? ?cab|double ?cab|quad ?cab|king ?cab|access ?cab|super ?cab|super ?crew|mega ?cab|super ?duty|f-? ?(150|250|350|450)|raptor|lightning|ranger|maverick|silverado|colorado|sierra|canyon|avalanche|ram ?(1500|2500|3500)|\bram\b|dakota|tacoma|tundra|frontier|titan|ridgeline|gladiator|santa ?cruz|cybertruck|r1t|hilux|2500 ?hd|3500 ?hd)\b/i;
  var MIDSIZE = /\b(tacoma|colorado|canyon|ridgeline|gladiator|ranger|maverick|frontier|santa ?cruz|rivian|r1t)\b/i;
  var FULLSIZE = /\b(expedition|suburban|yukon|tahoe|sequoia|escalade|navigator|armada|qx80|wagoneer|land ?cruiser)\b/i;
  var CAPTAIN = /\b(captain|bucket)/i;
  var LARGE = /\b(car|sedan|coupe|suv|crossover|hatch(back)?|mini ?van|van|wagon|jeep|wrangler|cherokee|bronco|4runner|highlander|explorer|pilot|passport|odyssey|sienna|pacifica|carnival|telluride|palisade|sorento|sportage|tucson|santa ?fe|rav ?4|cr-? ?v|hr-? ?v|outback|forester|crosstrek|ascent|impreza|legacy|cx-? ?\d+|equinox|traverse|blazer|trailblazer|acadia|terrain|durango|journey|escape|edge|flex|rogue|murano|pathfinder|kicks|x[1-7]|q[3-8]|gx|rx|nx|mdx|rdx|model ?[3sxy]|tiguan|atlas|golf|jetta|passat|camry|corolla|prius|civic|accord|altima|sentra|malibu|mustang|charger|challenger|outlander|xc\d+|enclave|encore|envision|venza|kona|ioniq|niro|seltos|soul|id\.?4|mach-?e)\b/i;
  function classify(t) {
    t = String(t || "").trim();
    if (!t) return null;
    if (CAPTAIN.test(t)) return "captain";
    if (MIDSIZE.test(t)) return "mid";
    if (PICKUP.test(t)) return "pickup";
    if (FULLSIZE.test(t)) return "fullsize";
    if (LARGE.test(t)) return "large";
    return "unknown";
  }
  var sizeBtns = $$('[data-tkd-choice="1"]');
  function sizeValue(kind) {
    var b = sizeBtns.filter(function (x) { return x.getAttribute("data-size") === kind; })[0];
    return b ? b.getAttribute("data-value") : null;
  }
  function pickSize(kind, source) {
    var v = sizeValue(kind);
    if (!v) return;
    sizeChosen = true;
    select(1, v, source);
    var b = sizeBtns.filter(function (x) { return x.getAttribute("data-size") === kind; })[0];
    if (b) { b.classList.remove("is-suggested"); void b.offsetWidth; b.classList.add("is-suggested"); }
  }
  var fitInput = $("[data-tkd-fit-input]"), fitGo = $("[data-tkd-fit-go]"), fitOut = $("[data-tkd-fit-result]");
  var fitCfg = data.fit || { type: "vehicle" };
  function weightSize(lb) {
    var ranges = fitCfg.ranges || [];
    for (var i = 0; i < ranges.length; i++) if (lb <= ranges[i].max) {
      var lastSize = i === ranges.length - 1;
      // a product whose rule is "near the top of a size, go one up": within nearTop lb of the top, the next size
      if (fitCfg.nearTop && !lastSize && lb >= ranges[i].max - fitCfg.nearTop) return { r: ranges[i + 1], i: i + 1, edge: false, up: ranges[i] };
      return { r: ranges[i], i: i, edge: lb === ranges[i].max && !lastSize };
    }
    return ranges.length ? { r: ranges[ranges.length - 1], i: ranges.length - 1, edge: false } : null;
  }
  function weightAnswer(raw, out, source, quiet, brief) {
    var lb = parseFloat(String(raw || "").replace(/[^\d.]/g, ""));
    if (!out) return null;
    out.hidden = false;
    out.textContent = "";
    var strong = document.createElement("b");
    if (!isFinite(lb) || lb <= 0) {
      strong.textContent = "Enter your dog's weight in pounds. ";
      out.appendChild(strong);
      return null;
    }
    var hit = weightSize(lb), first = (fitCfg.ranges || [])[0];
    if (!hit) return null;
    if (first && lb < first.min) {
      strong.textContent = hit.r.label + " is our smallest size. ";
      out.appendChild(strong);
      out.appendChild(document.createTextNode("It starts at " + first.min + " lb. Check the " + (first.chest ? "chest measurement (" + first.chest : "midsection measurement (" + first.mid) + " in) before you order."));
    } else if (fitCfg.over && lb > hit.r.max && hit.i === (fitCfg.ranges || []).length - 1) {
      // heavier than the largest size of this product: say so, and point to the product that fits
      strong.textContent = hit.r.label + " is the largest size. ";
      out.appendChild(strong);
      out.appendChild(document.createTextNode(fitCfg.over.text + " "));
      if (fitCfg.over.href) { var more = document.createElement("a"); more.href = fitCfg.over.href; more.textContent = fitCfg.over.link || "See it"; out.appendChild(more); }
      if (!quiet) emit("tk9_dtc_fit", { tk9_fit_kind: "over", tk9_source: source });
      return null;
    } else if (brief) {
      pickSize(hit.r.key, source);
      strong.textContent = hit.r.label + " ";
      out.appendChild(strong);
      out.appendChild(document.createTextNode((hit.up ? "is one up from " + hit.up.label + ": " + lb + " lb is near the top of that size. Fits" : "fits " + hit.r.range + " ·") + (hit.r.chest ? " chest " + hit.r.chest + " in ·" : "") + " midsection " + hit.r.mid + " in." + (hit.edge ? " Right at the top of this size: go one up." : "") + " "));
      if (sizeGuide) {
        var tapeBtn = document.createElement("button"); tapeBtn.type = "button"; tapeBtn.className = "tkd-linkbtn"; tapeBtn.textContent = "Check with a tape measure";
        tapeBtn.addEventListener("click", function () { openGuide("tape"); }); out.appendChild(tapeBtn);
      }
    } else {
      pickSize(hit.r.key, source);
      strong.textContent = "Start with " + hit.r.label + ". ";
      out.appendChild(strong);
      out.appendChild(document.createTextNode("Made for " + hit.r.range + ". Confirm with a tape measure: " + (hit.r.chest ? "chest " + hit.r.chest + " in, " : "") + "midsection " + hit.r.mid + " in." + (fitCfg.between ? " " + fitCfg.between : "")));
      if (hit.r.quote && hit.r.quote.q) {
        var proof = document.createElement("span");
        proof.className = "tkd-fit-proof";
        proof.appendChild(document.createTextNode("\u201c" + hit.r.quote.q + "\u201d "));
        var who = document.createElement("b");
        who.textContent = hit.r.quote.n + (hit.r.quote.verified ? ", verified buyer" : "");
        proof.appendChild(who);
        out.appendChild(proof);
      }
    }
    if (!quiet) emit("tk9_dtc_fit", { tk9_fit_kind: hit.r.key, tk9_source: source });
    return hit;
  }
  function runFit() {
    if (!fitInput || !fitOut) return;
    var q = fitInput.value.trim().slice(0, 60);
    if (!q) { fitInput.focus(); return; }
    if (fitCfg.type === "weight") { weightAnswer(q, fitOut, "fit"); return; }
    var kind = classify(q);
    fitOut.hidden = false;
    fitOut.textContent = "";
    var strong = document.createElement("b");
    if (kind === "pickup") {
      pickSize("xl", "fit");
      strong.textContent = "Extra-Large. ";
      fitOut.appendChild(strong);
      fitOut.appendChild(document.createTextNode("Pickups take the Extra-Large (55.5 in wide panel). We selected it for you."));
    } else if (kind === "large") {
      pickSize("large", "fit");
      strong.textContent = "Large. ";
      fitOut.appendChild(strong);
      fitOut.appendChild(document.createTextNode("Fits most cars, SUVs, minivans and Jeeps (50.4 in wide panel). We selected it for you."));
    } else if (kind === "mid") {
      strong.textContent = "Large or Extra-Large. ";
      fitOut.appendChild(strong);
      fitOut.appendChild(document.createTextNode("Mid-size pickup owners fit both sizes. Measure across your rear bench: Large is 50.4 in wide, Extra-Large is 55.5 in."));
    } else if (kind === "fullsize") {
      strong.textContent = "Large or Extra-Large. ";
      fitOut.appendChild(strong);
      fitOut.appendChild(document.createTextNode("Measure across your second-row bench: Large is 50.4 in wide, Extra-Large is 55.5 in. Some Expedition and Yukon owners in our reviews chose Extra-Large."));
    } else if (kind === "captain") {
      strong.textContent = "Captain's chairs? ";
      fitOut.appendChild(strong);
      fitOut.appendChild(document.createTextNode("This cover is made for bench seats. "));
      var a = document.createElement("a");
      a.href = "/products/single-seat-cover";
      a.textContent = "See the Single Seat Cover";
      fitOut.appendChild(a);
    } else {
      strong.textContent = "Is it a pickup truck? ";
      fitOut.appendChild(strong);
      fitOut.appendChild(document.createTextNode("Choose Extra-Large for pickups and Large for everything else."));
    }
    emit("tk9_dtc_fit", { tk9_fit_kind: kind });
    // add what owners of the same vehicle said, when the review index has it
    loadVehicles(function () {
      var hit = matchVehicle(q);
      if (!hit || !fitOut) return;
      var proof = document.createElement("span");
      proof.className = "tkd-fit-proof";
      proof.appendChild(document.createTextNode("“" + hit.quotes[0].q + "” "));
      var who = document.createElement("b");
      who.textContent = hit.quotes[0].n + ", verified buyer";
      proof.appendChild(who);
      fitOut.appendChild(proof);
    });
  }

  /* =================== weight finder (fit section) =================== */
  var weightBox = $("[data-tkd-weight]");
  if (weightBox) {
    var wIn = $("[data-tkd-weight-input]", weightBox), wGo = $("[data-tkd-weight-go]", weightBox), wOut = $("[data-tkd-weight-out]", weightBox);
    var runWeight = function (raw, quiet) {
      var hit = weightAnswer(raw, wOut, "finder", quiet);
      $$("[data-tkd-size-card]").forEach(function (c) {
        var match = !!hit && c.getAttribute("data-tkd-size-card") === hit.r.key;
        c.setAttribute("data-match", String(match));
        var row = c.parentNode;   // on phones the cards are a swipe row: bring the matching one to the middle
        if (match && row && row.scrollWidth > row.clientWidth + 8) row.scrollTo({ left: c.offsetLeft - row.offsetLeft - (row.clientWidth - c.clientWidth) / 2, behavior: reduceMotion ? "auto" : "smooth" });
      });
      if (hit && wOut) {
        var go = document.createElement("button");
        go.type = "button"; go.className = "tkd-cta tkd-cta--inline"; go.textContent = "Choose " + hit.r.label;
        go.addEventListener("click", function () { pickSize(hit.r.key, "finder"); toBuy($(".tkd-sizes") ? $(".tkd-sizes").closest("fieldset") : buy); emit("tk9_dtc_to_buy", { tk9_source: "finder" }); });
        var wrap = document.createElement("span"); wrap.className = "tkd-weight-act"; wrap.appendChild(go); wOut.appendChild(wrap);
      }
    };
    if (wGo) wGo.addEventListener("click", function () { if (wIn && !wIn.value.trim()) { wIn.focus(); return; } runWeight(wIn.value); });
    if (wIn) wIn.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); runWeight(wIn.value); } });
    $$("[data-tkd-weight-chip]", weightBox).forEach(function (c) {
      c.addEventListener("click", function () { if (wIn) wIn.value = c.getAttribute("data-tkd-weight-chip"); setSliders(Number(c.getAttribute("data-tkd-weight-chip"))); runWeight(c.getAttribute("data-tkd-weight-chip")); });
    });
  }
  /* weight sliders (one in the buy box, one in the size finder): they move together and pick the size as they go */
  var sliders = $$("[data-tkd-wslide]");
  function setSliders(lb, except) {
    sliders.forEach(function (bx) {
      var si = $("[data-tkd-wslide-input]", bx), so = $("[data-tkd-wslide-out]", bx);
      if (si && si !== except) si.value = lb;
      if (so) so.textContent = lb + " lb";
      bx.setAttribute("data-used", "true");
    });
  }
  sliders.forEach(function (bx) {
    var si = $("[data-tkd-wslide-input]", bx); if (!si) return;
    var inFinder = !!(weightBox && weightBox.contains(bx));
    var move = function (done) {
      var lb = Number(si.value);
      setSliders(lb, si);
      if (inFinder && typeof runWeight === "function") runWeight(lb, !done);
      else weightAnswer(lb, fitOut, "slider", !done, true);
      if (labRender) labRender(lb, !done);
    };
    si.addEventListener("input", function () { move(false); });
    si.addEventListener("change", function () { move(true); });
  });
  /* =================== fit lab: weight zones, tape check, pickable chart (one instance; moves into the size guide) =================== */
  var lab = $("[data-tkd-fitlab]"), labRender = null;
  if (lab && fitCfg.type === "weight") {
    var labOut = $("[data-tkd-fitlab-out]", lab), labRanges = fitCfg.ranges || [], labLb = null;
    var labSpan = function (s) { var m = String(s || "").match(/[\d.]+/g); return m && m.length > 1 ? [Number(m[0]), Number(m[1])] : null; };
    var labName = function (k) { var m = (fitCfg.measures || []).filter(function (x) { return x.key === k; })[0]; return m ? m.label : k; };
    var labMark = function (key) { $$("[data-tkd-size-card]").forEach(function (c) { c.setAttribute("data-match", String(!!key && c.getAttribute("data-tkd-size-card") === key)); }); };
    var labLine = function (ul, ok, text) { var li = document.createElement("li"); li.setAttribute("data-ok", ok); li.textContent = text; ul.appendChild(li); };
    labRender = function (lb, quiet) {
      if (lb !== undefined && lb !== null) labLb = lb;
      var ms = {}, first = labRanges[0], lastR = labRanges[labRanges.length - 1];
      $$("[data-tkd-measure]", lab).forEach(function (inp) { var val = parseFloat(inp.value); if (isFinite(val) && val > 0) ms[inp.getAttribute("data-tkd-measure")] = val; });
      var keys = Object.keys(ms), byW = labLb === null ? null : weightSize(labLb);
      $$("[data-tkd-zone-key]", lab).forEach(function (z) { z.setAttribute("data-on", String(!!byW && labLb >= first.min && labLb <= lastR.max && z.getAttribute("data-tkd-zone-key") === byW.r.key)); });
      labOut.textContent = "";
      if (!byW && !keys.length) { labOut.hidden = true; labMark(null); return; }
      labOut.hidden = false;
      var head = document.createElement("b"); head.className = "tkd-fl-pick"; labOut.appendChild(head);
      if (byW && fitCfg.over && labLb > lastR.max) {   // heavier than this product's largest size
        head.textContent = lastR.label + " is the largest size.";
        var po = document.createElement("p"); po.appendChild(document.createTextNode(fitCfg.over.text + " "));
        if (fitCfg.over.href) { var oa = document.createElement("a"); oa.href = fitCfg.over.href; oa.textContent = fitCfg.over.link || "See it"; po.appendChild(oa); }
        labOut.appendChild(po); labMark(null); return;
      }
      // sizes that every entered measurement fits; the tape decides when it disagrees with weight
      var fits = labRanges.filter(function (r) { return keys.every(function (k) { var s = labSpan(r[k]); return !s || (ms[k] >= s[0] && ms[k] <= s[1]); }); });
      var pick = null, tape = false, under = !!byW && labLb < first.min;
      if (!keys.length) pick = byW.r;
      else if (fits.length) { if (byW && fits.indexOf(byW.r) > -1) pick = byW.r; else { pick = fitCfg.tie === "up" ? fits[fits.length - 1] : fits[0]; tape = !!byW; } }
      var note = "";
      if (!pick) { head.textContent = "Between sizes."; note = "No single size fits every measurement you entered. " + (fitCfg.between || ""); }
      else if (tape) { head.textContent = "Go with " + pick.label + "."; note = "By weight alone it would be " + byW.r.label + ", but the tape measure says " + pick.label + ". The tape measure decides."; }
      else if (under) { head.textContent = pick.label + " is our smallest size."; note = "It starts at " + first.min + " lb. Check the measurements before you order."; }
      else if (byW && byW.up && !keys.length) { head.textContent = "Go one up: " + pick.label + "."; note = fitCfg.between || ""; }
      else if (keys.length) head.textContent = pick.label + " is your size.";
      else { head.textContent = "Start with " + pick.label + "."; if (byW.edge) note = fitCfg.between || ""; }
      var ul = document.createElement("ul"); ul.className = "tkd-fl-checks";
      // the largest size has an open top ("170+ lb") unless the product sends heavier dogs elsewhere (fit.over)
      var inW = !!byW && !!pick && labLb >= pick.min && (labLb <= pick.max || (pick === lastR && !fitCfg.over));
      if (byW && pick && byW.up && pick === byW.r) labLine(ul, "true", labLb + " lb is near the top of " + byW.up.label + " (" + byW.up.range + "), so the next size up fits better");
      else if (byW && pick) labLine(ul, String(inW), labLb + " lb " + (inW ? "is in the " + pick.range + " range" : "is outside " + pick.label + "’s " + pick.range));
      keys.forEach(function (k) {
        var s = pick ? labSpan(pick[k]) : null, ok = !!s && ms[k] >= s[0] && ms[k] <= s[1];
        labLine(ul, pick ? String(ok) : "false", labName(k) + " " + ms[k] + " in" + (pick && s ? (ok ? " fits " : " is outside ") + pick[k] + " in" : " does not line up with the other measurement"));
      });
      if (!keys.length && pick) labLine(ul, "hint", "Have a tape measure? Add " + (fitCfg.measures || []).map(function (m) { return m.label.toLowerCase(); }).join(" and ") + " above to confirm.");
      labOut.appendChild(ul);
      if (note) { var pn = document.createElement("p"); pn.textContent = note; labOut.appendChild(pn); }
      if (pick && pick.quote && pick.quote.q) {
        var bq = document.createElement("p"); bq.className = "tkd-fl-say";
        bq.appendChild(document.createTextNode("“" + pick.quote.q + "” "));
        var who = document.createElement("b"); who.textContent = pick.quote.n + (pick.quote.verified ? ", verified buyer" : ""); bq.appendChild(who); labOut.appendChild(bq);
      }
      labMark(pick ? pick.key : null);
      $$("[data-tkd-size-photo]", lab).forEach(function (f) { f.hidden = !pick || f.getAttribute("data-tkd-size-photo") !== pick.key; });
      if (pick) {
        if (!under) pickSize(pick.key, "fitlab");
        if (keys.length && fitOut) {   // keep the buy box line in step with a tape-based pick
          fitOut.hidden = false; fitOut.textContent = "";
          var fb = document.createElement("b"); fb.textContent = pick.label + " "; fitOut.appendChild(fb);
          fitOut.appendChild(document.createTextNode("by your tape measure: " + keys.map(function (k) { return labName(k).toLowerCase() + " " + ms[k] + " in"; }).join(", ") + "."));
        }
        var go = document.createElement("button"); go.type = "button"; go.className = "tkd-cta tkd-cta--inline"; go.setAttribute("data-tkd-fitlab-choose", pick.key); go.textContent = "Choose " + pick.label;
        go.addEventListener("click", function () { pickSize(pick.key, "fitlab"); toBuy($(".tkd-sizes") ? $(".tkd-sizes").closest("fieldset") : buy); emit("tk9_dtc_to_buy", { tk9_source: "fitlab" }); });
        labOut.appendChild(go);
      }
      if (!quiet) emit("tk9_dtc_fit", { tk9_fit_kind: pick ? pick.key : "between", tk9_source: "fitlab", tk9_tape: keys.length });
    };
    $$("[data-tkd-measure]", lab).forEach(function (inp) {
      inp.addEventListener("input", function () { labRender(null, true); });
      inp.addEventListener("change", function () { labRender(null, false); });
    });
    $$("[data-tkd-zone]", lab).forEach(function (z) {
      z.addEventListener("click", function () { var lb = Number(z.getAttribute("data-tkd-zone")); setSliders(lb); weightAnswer(lb, fitOut, "zone", false, true); labRender(lb, false); });
    });
    lab.addEventListener("click", function (e) { if (e.target.closest("[data-tkd-pick-size], [data-tkd-fitlab-choose]") && sizeGuide && sizeGuide.open) closeGuide(); });
  }
  $$("details.tkd-addons").forEach(function (d) { d.addEventListener("toggle", function () { window.dispatchEvent(new Event("resize")); }); });

  /* =================== vehicle matcher (verified 5-star reviews by vehicle) =================== */
  var matchBox = $("[data-tkd-match]"), vehicles = null, vehiclesLoading = null, matchShown = "", matchDims = null;
  try { matchDims = matchBox ? JSON.parse(matchBox.getAttribute("data-dims") || "null") : null; } catch (e) { matchDims = null; }
  function loadVehicles(done) {
    if (vehicles) { done(); return; }
    var src = matchBox && matchBox.getAttribute("data-src");
    if (!src) return;
    if (!vehiclesLoading) {
      vehiclesLoading = fetch(src).then(function (r) { return r.ok ? r.json() : { vehicles: [] }; }).then(function (j) {
        vehicles = (j.vehicles || []).map(function (v) {
          try { v.re = new RegExp(v.rx, "i"); } catch (e) { v.re = null; }
          return v;
        }).filter(function (v) { return v.re; }).sort(function (a, b) { return b.rx.length - a.rx.length; });
        var list = $("[data-tkd-match-list]");   // suggestions as you type: every vehicle the review index knows by name
        if (list && !list.children.length) vehicles.slice().sort(function (a, b) { return b.count - a.count; }).forEach(function (v) {
          if (!v.re.test(v.label)) return;
          var o = document.createElement("option"); o.value = v.label; list.appendChild(o);
        });
      }).catch(function () { vehicles = []; });
    }
    vehiclesLoading.then(done);
  }
  function matchVehicle(q) {
    for (var i = 0; vehicles && i < vehicles.length; i++) if (vehicles[i].re.test(q)) return vehicles[i];
    return null;
  }
  function el(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
  function renderMatch(q, forced) {   // forced = { kind, label, hint } from a vehicle type tile
    var out = $("[data-tkd-match-out]");
    if (!out) return;
    q = String(q || "").trim().slice(0, 60);
    if (!q) return;
    var hit = forced ? null : matchVehicle(q), kind = forced ? forced.kind : hit ? hit.kind : classify(q);
    matchShown = hit ? hit.label : "";
    out.textContent = "";
    out.hidden = false;
    var card = el("div", "tkd-match-card");
    var sizeText = kind === "xl" || kind === "pickup" ? "Extra-Large" : kind === "l" || kind === "large" ? "Large" : kind === "captain" ? "" : "Large or Extra-Large";
    var head = el("p", "tkd-match-head");
    head.appendChild(el("span", "", hit ? hit.label : forced ? forced.label : q));
    if (sizeText) head.appendChild(el("b", "", sizeText));
    card.appendChild(head);
    var why = "";
    if (kind === "xl" || kind === "pickup") why = "Full-size pickups take the Extra-Large (55.5 in wide seat panel).";
    else if (kind === "l" || kind === "large") why = "Cars, SUVs, minivans and Jeeps take the Large (50.4 in wide seat panel).";
    else if (kind === "mid") why = "Mid-size pickup owners fit both sizes. Measure across your rear bench: Large is 50.4 in wide, Extra-Large is 55.5 in.";
    else if (kind === "either" || kind === "fullsize") why = "Full-size SUVs vary. Measure across your second-row bench: Large is 50.4 in wide, Extra-Large is 55.5 in.";
    else if (kind === "captain") why = "This cover is made for bench seats. For captain's chairs, see the Single Seat Cover.";
    else why = "Choose Extra-Large for full-size pickups and Large for cars, SUVs, minivans and Jeeps.";
    if (hit && hit.kind === "mid" && hit.sizes && (hit.sizes.l || hit.sizes.xl)) {
      why += " Of the " + hit.label + " owners who named their size, " + (hit.sizes.l || 0) + " chose Large and " + (hit.sizes.xl || 0) + " chose Extra-Large.";
    }
    if (forced && kind === "mid") {   // what mid-size pickup owners chose, summed from the review index
      var nl = 0, nx = 0;
      (vehicles || []).forEach(function (v) { if (v.kind === "mid" && v.sizes) { nl += v.sizes.l || 0; nx += v.sizes.xl || 0; } });
      if (nl + nx > 1) why += " Of the mid-size pickup owners in our reviews who named their size, " + nl + " chose Large and " + nx + " chose Extra-Large.";
    }
    card.appendChild(el("p", "tkd-match-why", why));
    var want = kind === "xl" || kind === "pickup" ? ["xl"] : kind === "l" || kind === "large" ? ["large"] : kind === "captain" ? [] : ["large", "xl"];
    if (matchDims && want.length === 2) {   // two sizes could fit: show both seat panels to measure against
      var widest = Math.max(matchDims.large ? matchDims.large[0] : 0, matchDims.xl ? matchDims.xl[0] : 0), dl = el("div", "tkd-ride-dims");
      dl.appendChild(el("p", "", "Seat panel size"));
      [["large", "Large"], ["xl", "Extra-Large"]].forEach(function (s) {
        var d = matchDims[s[0]];
        if (!d) return;
        var row = el("div", "tkd-ride-dim"), bar = el("span", "tkd-ride-bar"), fill = el("i");
        fill.style.width = Math.round(d[0] / widest * 100) + "%";
        bar.appendChild(fill);
        row.appendChild(el("b", "", s[1])); row.appendChild(bar); row.appendChild(el("span", "", d[0] + " in wide \u00d7 " + d[1] + " in deep"));
        dl.appendChild(row);
      });
      card.appendChild(dl);
    }
    if (forced && forced.hint) card.appendChild(el("p", "tkd-match-hint", forced.hint));
    if (want.length === 1) pickSize(want[0], "matcher");   // one clear answer: the buy box follows right away
    if (hit) {
      card.appendChild(el("p", "tkd-match-count", hit.count + " five-star reviews mention the " + hit.label + "."));
      var list = el("ul", "tkd-match-quotes");
      hit.quotes.slice(0, 2).forEach(function (qt) {
        var li = el("li");
        var stars = el("span", "tkd-stars", "★★★★★"); stars.setAttribute("aria-hidden", "true");
        li.appendChild(stars);
        li.appendChild(el("q", "", qt.q));
        li.appendChild(el("b", "", qt.n + " · Verified buyer"));
        list.appendChild(li);
      });
      card.appendChild(list);
    }
    var actions = el("p", "tkd-match-actions");
    want.forEach(function (k) {
      var b = el("button", "tkd-cta tkd-cta--inline", "Choose " + (k === "xl" ? "Extra-Large" : "Large"));
      b.type = "button";
      b.addEventListener("click", function () {
        pickSize(k, "matcher");
        if (sizeGuide && sizeGuide.open) closeGuide();
        toBuy($(".tkd-sizes") ? $(".tkd-sizes").closest("fieldset") : buy);
        emit("tk9_dtc_to_buy", { tk9_source: "matcher" });
      });
      actions.appendChild(b);
    });
    if (kind === "captain") {
      var a = el("a", "tkd-cta tkd-cta--inline", "See the Single Seat Cover");
      a.href = "/products/single-seat-cover";
      actions.appendChild(a);
    }
    card.appendChild(actions);
    out.appendChild(card);
    emit("tk9_dtc_match", { tk9_fit_kind: kind, tk9_vehicle: hit ? hit.label : forced ? "type: " + forced.label : "unlisted" });
  }
  if (matchBox) {
    var matchInput = $("[data-tkd-match-input]", matchBox), matchGo = $("[data-tkd-match-go]", matchBox);
    var runMatch = function (q, forced) { loadVehicles(function () { renderMatch(q, forced); }); };
    var rideTypes = $$("[data-tkd-ride-type]", matchBox), matchChips = $$("[data-tkd-match-chip]", matchBox), liveTimer = null;
    var pressOnly = function (btn) { rideTypes.concat(matchChips).forEach(function (x) { x.setAttribute("aria-pressed", String(x === btn)); }); };
    rideTypes.forEach(function (b) {   // step 1: tap the kind of vehicle, get the size
      b.addEventListener("click", function () {
        pressOnly(b);
        if (matchInput) matchInput.value = "";
        var label = b.getAttribute("data-tkd-ride-label");
        runMatch(label, { kind: b.getAttribute("data-tkd-ride-type"), label: label, hint: b.getAttribute("data-tkd-ride-hint") || "" });
      });
    });
    if (matchInput) {
      matchInput.addEventListener("focus", function () { loadVehicles(function () {}); });
      matchInput.addEventListener("input", function () {   // answer as soon as a vehicle the review index knows is typed or picked
        clearTimeout(liveTimer);
        var q = matchInput.value;
        liveTimer = setTimeout(function () {
          loadVehicles(function () { var hit = matchVehicle(q); if (hit && hit.label !== matchShown) { pressOnly(null); renderMatch(q); } });
        }, 280);
      });
      matchInput.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); runMatch(matchInput.value); } });
    }
    if (matchGo) matchGo.addEventListener("click", function () { if (matchInput && !matchInput.value.trim()) { matchInput.focus(); return; } pressOnly(null); runMatch(matchInput.value); });
    matchChips.forEach(function (c) {
      c.addEventListener("click", function () {
        var q = c.getAttribute("data-tkd-match-chip");
        if (matchInput) matchInput.value = q;
        pressOnly(c);
        runMatch(q);
      });
    });
  }
  if (fitGo) fitGo.addEventListener("click", runFit);
  var fitToggle = $("[data-tkd-fit-toggle]"), fitBox = $("[data-tkd-fit]");
  if (fitToggle && fitBox) {
    fitToggle.addEventListener("click", function () {
      var open = fitBox.hidden;
      fitBox.hidden = !open;
      fitToggle.setAttribute("aria-expanded", String(open));
      if (open && fitInput) fitInput.focus();
      emit("tk9_dtc_fit_open", {});
    });
  }
  if (fitInput) fitInput.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); runFit(); } });

  /* =================== scroll to buy box =================== */
  var buy = $(".tkd-buy");
  function toBuy(target) {
    var el = target || buy;
    if (!el) return;
    var y0 = window.pageYOffset;
    el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    // Smooth scrolling can stall (throttled tabs, in-app browsers); make sure we still arrive.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - y0) < 4 && Math.abs(el.getBoundingClientRect().top) > 140) {
        el.scrollIntoView({ behavior: "instant", block: "start" });
      }
    }, 700);
  }
  $$("[data-tkd-pick-size]").forEach(function (b) {
    b.addEventListener("click", function () {
      pickSize(b.getAttribute("data-tkd-pick-size"), "fitguide");
      toBuy($(".tkd-sizes") ? $(".tkd-sizes").closest("fieldset") : buy);
      emit("tk9_dtc_to_buy", { tk9_source: "fitguide" });
    });
  });
  $$("[data-tkd-pick-color]").forEach(function (b) {
    b.addEventListener("click", function () {
      select(0, b.getAttribute("data-tkd-pick-color"), "colors");
      toBuy();
      emit("tk9_dtc_to_buy", { tk9_source: "colors" });
    });
  });
  // Shop the look: a product photo that sets its own color (and kit) in the buy box
  $$("[data-tkd-look]").forEach(function (b) {
    b.addEventListener("click", function () {
      var col = b.getAttribute("data-look-color"), set = b.getAttribute("data-look-setup");
      if (col) select(0, col, "look");
      if (set) { if (data.builder) setLines([]); select(2, set, "look"); }   // the photo's kit, exactly: extras ticked before it are cleared
      toBuy();
      emit("tk9_dtc_to_buy", { tk9_source: "look", tk9_look: b.getAttribute("data-el") || "" });
    });
  });
  $$("[data-tkd-looks-all]").forEach(function (b) {
    b.addEventListener("click", function () {
      var grid = b.closest(".tkd-looks").querySelector(".tkd-looks-grid");
      if (grid) grid.removeAttribute("data-collapsed");
      b.parentNode.hidden = true;
      emit("tk9_dtc_looks_all", {});
    });
  });
  $$("[data-tkd-pick-setup]").forEach(function (b) {
    b.addEventListener("click", function () {
      var want = b.getAttribute("data-tkd-pick-setup"), exact = b.getAttribute("data-tkd-pick-setup-value");
      if (exact) select(2, exact, "story");
      else {
        var opt = $$('[data-tkd-choice="2"]').filter(function (x) { return (want === "bed") === /bed/i.test(x.getAttribute("data-value")); })[0];
        if (opt) select(2, opt.getAttribute("data-value"), "story");
      }
      toBuy($(".tkd-setups") ? $(".tkd-setups").closest("fieldset") : buy);
      emit("tk9_dtc_to_buy", { tk9_source: "story-" + want });
    });
  });

  $$("[data-tkd-fit-open]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (fitBox) { fitBox.hidden = false; if (fitToggle) fitToggle.setAttribute("aria-expanded", "true"); }
      toBuy($(".tkd-sizes") ? $(".tkd-sizes").closest("fieldset") : buy);
      if (fitInput) setTimeout(function () { try { fitInput.focus({ preventScroll: true }); } catch (e) { fitInput.focus(); } }, 650);
      emit("tk9_dtc_fit_open", { tk9_source: "fitguide" });
    });
  });

  var sizeGuide = $("[data-tkd-sizeguide]"), labHome = null, labNext = null, matchHome = null, matchNext = null;
  function restoreLab() {
    if (lab && labHome && lab.parentNode !== labHome) labHome.insertBefore(lab, labNext);
    if (matchBox && matchHome && matchBox.parentNode !== matchHome) matchHome.insertBefore(matchBox, matchNext);
  }
  function closeGuide() {
    if (!sizeGuide) return;
    if (typeof sizeGuide.close === "function" && sizeGuide.open) sizeGuide.close();
    else sizeGuide.removeAttribute("open");
    restoreLab();
  }
  function openGuide(mode) {   // the fit lab is one component: it moves into the dialog while the dialog is open
    if (!sizeGuide) return;
    $$("img[data-src]", sizeGuide).forEach(function (img) { img.src = img.getAttribute("data-src"); img.removeAttribute("data-src"); });
    var mount = $("[data-tkd-fitlab-mount]", sizeGuide);
    if (lab && mount && lab.parentNode !== mount) { labHome = lab.parentNode; labNext = lab.nextSibling; mount.appendChild(lab); }
    var rideMount = $("[data-tkd-match-mount]", sizeGuide);   // the ride finder moves in the same way
    if (matchBox && rideMount && matchBox.parentNode !== rideMount) { matchHome = matchBox.parentNode; matchNext = matchBox.nextSibling; rideMount.appendChild(matchBox); matchBox.classList.add("is-in"); }
    if (typeof sizeGuide.showModal === "function") { if (!sizeGuide.open) sizeGuide.showModal(); }
    else sizeGuide.setAttribute("open", "");
    if (mode === "tape") { var mi = $("[data-tkd-measure]", sizeGuide); if (mi) setTimeout(function () { mi.focus(); }, 150); }
    emit("tk9_dtc_sizeguide", { tk9_mode: mode === "tape" ? "tape" : "guide" });
  }
  if (sizeGuide) {
    $$("[data-tkd-sizeguide-open]").forEach(function (b) { b.addEventListener("click", function () { openGuide(); }); });
    sizeGuide.addEventListener("close", restoreLab);
    $$("[data-tkd-sizeguide-close]").forEach(function (b) { b.addEventListener("click", closeGuide); });
    sizeGuide.addEventListener("click", function (e) { if (e.target === sizeGuide) closeGuide(); });
    $$("[data-tkd-modal-pick]", sizeGuide).forEach(function (b) { b.addEventListener("click", closeGuide); });
  }

  var wall = $("[data-tkd-wall]"), wallCount = $("[data-tkd-wall-count]");
  if (wall && wallCount) {
    var tiles = wall.children.length;
    wallCount.textContent = "1 / " + tiles;
    wall.addEventListener("scroll", function () {
      var i = Math.round(wall.scrollLeft / Math.max(1, wall.children[0].offsetWidth)) + 1;
      var next = clamp(i, 1, tiles) + " / " + tiles;
      if (wallCount.textContent !== next) wallCount.textContent = next;
    }, { passive: true });
  }

  $$("[data-tkd-to-buy]").forEach(function (a) {
    a.addEventListener("click", function (e) { e.preventDefault(); toBuy(); emit("tk9_dtc_to_buy", { tk9_source: a.getAttribute("data-el") || "" }); });
  });

  /* =================== add-ons ("Complete the ride") =================== */
  $$("[data-tkd-addon-input]").forEach(function (input) {
    var item = addons.filter(function (a) { return String(a.id) === input.value; })[0];
    if (!item) return;
    input.addEventListener("change", function () {
      item.on = input.checked;
      item.added = false;
      render();
      emit("tk9_dtc_addon", { tk9_on: item.on, tk9_addon: item.name, tk9_variant_id: item.id });
    });
  });
  if (namePatch && npItem) {
    var npToggle = $("[data-tkd-namepatch-toggle]", namePatch), npFields = $("[data-tkd-namepatch-fields]", namePatch);
    var npSync = function () {
      var t = npText();
      text("[data-tkd-namepatch-l1]", t.name || (namePatch.querySelector("[data-tkd-namepatch-name]") || {}).placeholder || "");
      text("[data-tkd-namepatch-l2]", t.phone || (t.name ? "" : (namePatch.querySelector("[data-tkd-namepatch-phone]") || {}).placeholder || ""));
      text("[data-tkd-namepatch-summary]", [t.name, t.phone].filter(Boolean).join(" · ") || "One pair, printed");
      $$("[data-tkd-np-on]").forEach(function (on) {   // the name on the harness photo: shrink a long line to fit the patch
        [].forEach.call(on.children, function (line) {   // a smaller type size, not a transform, so the line stays centered
          line.style.fontSize = "";
          var room = on.clientWidth * 0.92, w = line.scrollWidth;
          if (w > room && w > 0) line.style.fontSize = (parseFloat(getComputedStyle(line).fontSize) * room / w).toFixed(2) + "px";
        });
      });
      var err = $("[data-tkd-error]");
      if (err && err.getAttribute("data-kind") === "patch" && !needPatchText()) { err.hidden = true; err.removeAttribute("data-kind"); }
    };
    if (npToggle) npToggle.addEventListener("change", function () {
      npItem.on = npToggle.checked; npItem.added = false;
      if (npFields) npFields.hidden = !npToggle.checked;
      namePatch.setAttribute("data-on", String(npToggle.checked));
      npSync(); render();
      emit("tk9_dtc_addon", { tk9_on: npItem.on, tk9_addon: npItem.name });
    });
    $$("input[type=text], input[type=tel]", namePatch).forEach(function (i) { i.addEventListener("input", function () { npItem.added = false; npSync(); }); });
    npSync();
  }

  /* build-your-kit picker: parts toggle on and off, the set resolves to one kit variant */
  var builder = data.builder || null;
  function builderParts(value) {
    if (!builder) return null;
    for (var k in builder.map) if (builder.map[k] === value) return k ? k.split("+") : [];
    return null;   // a bundle outside the map (the full system): every part is in it
  }
  function builderKey(parts) { return builder.parts.filter(function (p) { return parts.indexOf(p) > -1; }).join("+"); }
  if (builder) {
    $$("[data-tkd-part]").forEach(function (b) {
      b.addEventListener("click", function () {
        var part = b.getAttribute("data-tkd-part"), cur = selParts();
        var i = cur.indexOf(part);
        if (i > -1) cur.splice(i, 1); else cur.push(part);
        var fit = resolveKit(cur);
        if (!fit) return;
        setLines(fit.lines);
        select(2, fit.value, "builder");
        emit("tk9_dtc_kit_part", { tk9_part: part, tk9_on: i === -1, tk9_as: fit.lines.indexOf(part) > -1 ? "line" : "kit" });
      });
    });
    $$("[data-tkd-bundle]").forEach(function (bb) {
      bb.addEventListener("click", function () {
        var fit = resolveKit(bb.getAttribute("data-tkd-bundle").split("+"));
        if (!fit) return;
        setLines(fit.lines);
        select(2, fit.value, "bundle");
      });
    });
  }

  // Arrow buttons for the add-on rail (mouse users cannot swipe it).
  var rail = $("[data-tkd-addon-rail]"), railNav = $$("[data-tkd-rail-nav]");
  function refreshRail() {
    if (!rail) return;
    var max = rail.scrollWidth - rail.clientWidth;
    railNav.forEach(function (b) {
      var dir = Number(b.getAttribute("data-tkd-rail-nav"));
      b.hidden = max < 8 || (dir < 0 ? rail.scrollLeft < 8 : rail.scrollLeft > max - 8);
    });
  }
  if (rail && railNav.length) {
    railNav.forEach(function (b) {
      b.addEventListener("click", function () {
        rail.scrollBy({ left: Number(b.getAttribute("data-tkd-rail-nav")) * Math.max(160, rail.clientWidth * 0.6), behavior: reduceMotion ? "auto" : "smooth" });
        setTimeout(refreshRail, 450);
      });
    });
    rail.addEventListener("scroll", refreshRail, { passive: true });
    window.addEventListener("resize", refreshRail);
    refreshRail();
  }

  // Adds the chosen add-ons first, then replays a real click on the add button so the storefront's own
  // add-to-cart path (native form, Team K9 cart, or the upsell popup app on the live theme) runs as usual.
  var resuming = false;
  // One add at a time (audit 2026-11-01): a second tap on the sticky or final button while the add-ons are
  // still being added used to start a second round, and the cart got two harnesses.
  var addingAddons = false;
  function submitMain(btn) {
    if (!form || addingAddons) return;
    function go() {
      addingAddons = false;
      var b = btn || $("[data-tkd-add]");
      if (b) b.classList.remove("is-busy");
      if (b && typeof b.click === "function") { resuming = true; try { b.click(); } finally { resuming = false; } }
      else if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.submit();
    }
    var pending = pendingAddons();
    if (!pending.length) { go(); return; }
    addingAddons = true;
    if (btn) btn.classList.add("is-busy");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: pending.map(function (a) { return { id: a.variantId ? a.variantId() : a.id, quantity: 1, properties: a.props ? a.props() : { _tk9_lander: landerKey + ":addon" } }; }) })
    }).then(function (r) {
      if (r.ok) {
        pending.forEach(function (a) { a.added = true; });
        emit("tk9_dtc_addon_added", { tk9_count: pending.length });
      }
    }).catch(function () { /* the cover still gets added */ }).then(go);
  }

  /* =================== quantity row (see QTY_DEALS) =================== */
  function qtyTotals(v) { return qtyDeal && v ? qtyDeal.totals[v.price] || null : null; }
  function qtyBuild() {
    if (qtyRow || !qtyDeal || !form) return;
    var btn = $("[data-tkd-add]", form);
    if (!btn) return;
    var anchor = btn; while (anchor.parentElement && anchor.parentElement !== form) anchor = anchor.parentElement;
    if (anchor.parentElement !== form) return;
    var n = 0; for (var pk in qtyDeal.totals) { n = qtyDeal.totals[pk].length; break; }
    var html = '<legend>Quantity</legend><div class="tk9-qty-row" style="--n: ' + n + '">';
    for (var i = 0; i < n; i++) {
      html += '<button type="button" class="tk9-qty-opt" data-tk9-qty-opt="' + (i + 1) + '" aria-pressed="' + (i === 0) + '">' +
        (i === 1 ? '<em class="tk9-qty-tag">Most popular</em>' : "") + "<b>Buy " + (i + 1) + "</b>" +
        '<small class="tk9-qty-each"><span data-tk9-qty-each></span>' + (i ? " each" : "") + "</small>" +
        '<i class="tk9-qty-off" data-tk9-qty-off hidden></i></button>';
    }
    qtyRow = document.createElement("fieldset");
    qtyRow.className = "tk9-qty";
    qtyRow.setAttribute("data-tk9-qty", "");
    qtyRow.hidden = true;
    qtyRow.innerHTML = html + "</div>";
    form.insertBefore(qtyRow, anchor);
    var st = document.createElement("style"); st.textContent = QTY_CSS; root.appendChild(st);
    watchName(qtyRow, "tkd.qty", "variant");
    $$("[data-tk9-qty-opt]", qtyRow).forEach(function (b) {
      watchName(b, "tkd.qty.buy-" + b.getAttribute("data-tk9-qty-opt"), "variant");
      b.addEventListener("click", function () {
        qtyIdx = Number(b.getAttribute("data-tk9-qty-opt")) - 1;
        render(-1);
        emit("tk9_dtc_qty", { tk9_value: qtyIdx + 1 });
      });
    });
    // Buy-box test (2026-10-18, sections/tk9-bb-tests.liquid): a visitor in a test's B arm starts on that quantity
    // (window.TK9BB_QTY by product handle). Unset for everyone else, so the row starts on Buy 1 as before.
    var bbQty = window.TK9BB_QTY && Number(window.TK9BB_QTY[root.getAttribute("data-tkd-product") || ""]);
    if (bbQty > 1 && bbQty <= n) qtyIdx = bbQty - 1;
  }
  function qtyRender(v) {
    if (!qtyDeal) return;
    qtyBuild();
    var t = qtyTotals(v);
    if (!t || !v.available) qtyIdx = 0;
    if (qtyRow) qtyRow.hidden = !t;
    var fmt = v.price_fmt, q = t ? qtyIdx + 1 : 1;
    if (qtyRow && t) $$("[data-tk9-qty-opt]", qtyRow).forEach(function (b, i) {
      b.setAttribute("aria-pressed", String(i === qtyIdx));
      var each = Math.round(t[i] / (i + 1)), off = v.price - each, e = $("[data-tk9-qty-each]", b), o = $("[data-tk9-qty-off]", b);
      if (e) e.textContent = money(each, fmt);
      if (o) { o.hidden = !(i > 0 && off > 0); o.textContent = o.hidden ? "" : "Save " + money(off, fmt) + " each"; }
    });
    // The form carries the quantity (and, for a Kaching deal, Kaching's own line property); the store's own
    // add-to-cart path reads the form as before.
    var qi = form && form.querySelector('[name="quantity"]');
    if (qi) qi.value = String(q);
    if (qtyDeal.kaching && form) {
      var k = qtyDeal.kaching, pi = form.querySelector('[name="properties[__kaching_bundles]"]');
      if (!pi) { pi = document.createElement("input"); pi.type = "hidden"; pi.name = "properties[__kaching_bundles]"; form.appendChild(pi); }
      pi.value = JSON.stringify({ deal: k.deal, pp: k.pp, main: true, bid: k.bids[q - 1] });
      // On a product URL Kaching's own (hidden) widget is in the page and writes the quantity and its property on
      // submit from its own chosen bar: choose the same bar there, then put the lander's variant and values back.
      var kb = document.querySelector("kaching-bundles-block"), kr = kb && kb.querySelector('input[type="radio"][value="' + k.bids[q - 1] + '"]');
      if (kr && !kr.checked) {
        kr.click();
        var vid = v.id;
        setTimeout(function () {
          if (idInput && current && current.id === vid) idInput.value = String(vid);
          if (qi) qi.value = String(q);
          if (pi) pi.value = JSON.stringify({ deal: k.deal, pp: k.pp, main: true, bid: k.bids[q - 1] });
        }, 0);
      }
    }
    if (q > 1) {
      var total = t[q - 1] + addonTotal(), totalFmt = money(total, fmt), label = $("[data-tkd-add-label]");
      if (label && v.available) label.textContent = "Add to cart · " + totalFmt;
      text("[data-tkd-sticky-price]", totalFmt);
      text("[data-tkd-stack-total]", totalFmt);
      text("[data-tkd-final-total]", totalFmt);
      text("[data-tkd-stack-price]", money(t[q - 1], fmt));
      $$("[data-tkd-stack-name]").forEach(function (n) { n.textContent = q + " × " + n.textContent; });
      $$("[data-tkd-stack-compare]").forEach(function (n) { n.hidden = false; n.textContent = money(v.price * q, fmt); });
      $$('[data-tkd-submit="final"]').forEach(function (b) { if (!needSize() && v.available) b.textContent = "Add to cart · " + totalFmt; });
    }
  }

  /* =================== add to cart =================== */
  var addBtn = $("[data-tkd-add]");
  function promptPatch() {
    var f = $("[data-tkd-namepatch-fields]", namePatch), n = $("[data-tkd-namepatch-name]", namePatch);
    if (f) f.hidden = false;
    toBuy(namePatch);
    var err = $("[data-tkd-error]");
    if (err) { err.textContent = "Type the name or phone number for your custom patches, or untick them."; err.setAttribute("data-kind", "patch"); err.hidden = false; }
    if (n) setTimeout(function () { try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }, 500);
    emit("tk9_dtc_need_patch_text", {});
  }
  function promptSize(source) {
    var set = $(".tkd-sizes"), field = set ? set.closest("fieldset") : null;
    toBuy(field || buy);
    $$('[data-tkd-choice="1"]', set || root).forEach(function (b) {
      b.classList.remove("is-suggested");
      void b.offsetWidth;
      b.classList.add("is-suggested");
    });
    $$('[data-tkd-opt-label="1"]').forEach(function (n) { n.classList.add("is-needed"); });
    var err = $("[data-tkd-error]");
    if (err) { err.textContent = data.sizePrompt || "Choose a size to add it to your cart."; err.setAttribute("data-kind", "size"); err.hidden = false; }
    emit("tk9_dtc_need_size", { tk9_source: source || "add" });
  }
  // Runs in the capture phase at window level (registered by the inline stub in the section, before
  // app scripts), so ticked add-ons are added before any other add-to-cart handler sees the click.
  window.__tkdAddClick = function (e) {
    var control = e.target && e.target.closest ? e.target.closest("[data-tkd-add]") : null;
    if (!control || resuming) return;
    if (addingAddons) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (handoff && data.product_url) { e.preventDefault(); e.stopImmediatePropagation(); emit("tk9_dtc_handoff", {}); window.location.href = data.product_url; return; }
    if (needSize()) { e.preventDefault(); e.stopImmediatePropagation(); promptSize("add"); return; }
    if (needPatchText()) { e.preventDefault(); e.stopImmediatePropagation(); promptPatch(); return; }
    if (!pendingAddons().length || !current || !current.available) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submitMain(control);
  };
  if (form) {
    form.addEventListener("submit", function (e) {
      var err = $("[data-tkd-error]");
      if (handoff && data.product_url) { e.preventDefault(); e.stopImmediatePropagation(); window.location.href = data.product_url; return; }
      if (needSize()) { e.preventDefault(); e.stopImmediatePropagation(); promptSize("submit"); return; }
      if (needPatchText()) { e.preventDefault(); e.stopImmediatePropagation(); promptPatch(); return; }
      if (!current || !current.available) {
        e.preventDefault();
        if (err) { err.textContent = "That combination is sold out. Try another color or setup."; err.hidden = false; }
        return;
      }
      if (err) err.hidden = true;
      if (addBtn) { addBtn.classList.add("is-busy"); setTimeout(function () { addBtn.classList.remove("is-busy"); }, 4000); }
      emit("tk9_dtc_add_attempt", { tk9_variant_id: current.id, tk9_value: current.price / 100 });
    }, false);
  }
  document.addEventListener("tk9_product_form_add", function (event) {
    var d = event.detail || {};
    if (current && String(d.tk9_variant_id || "") === String(current.id)) {
      if (addBtn) addBtn.classList.remove("is-busy");
      emit("tk9_dtc_add_success", { tk9_variant_id: current.id });
    }
  });
  $$("[data-tkd-submit]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (!form) return;
      if (handoff && data.product_url) { window.location.href = data.product_url; return; }
      if (needSize()) { promptSize(b.getAttribute("data-tkd-submit")); return; }
      if (needPatchText()) { promptPatch(); return; }
      if (b.getAttribute("data-tkd-submit") === "sticky" && !sizeChosen) {
        var sizeSet = $(".tkd-sizes");
        toBuy(sizeSet ? sizeSet.closest("fieldset") : buy);
        emit("tk9_dtc_sticky_choose_size", {});
        return;
      }
      if (!current || !current.available) { toBuy(); return; }
      emit("tk9_dtc_quick_add", { tk9_source: b.getAttribute("data-tkd-submit") });
      submitMain(addBtn);
    });
  });

  /* =================== sticky bar =================== */
  var sticky = $("[data-tkd-sticky]"), finalSec = $("[data-tkd-final]");
  var stickyBtn = $('[data-tkd-submit="sticky"]');
  function refreshSticky() {
    if (!stickyBtn) return;
    stickyBtn.textContent = !sizeChosen ? "Choose your size" : (current && current.available ? "Add to cart" : "See other options");
  }
  refreshSticky();
  function updateSticky() {
    if (!sticky || !addBtn) return;
    var vh = window.innerHeight, r = addBtn.getBoundingClientRect();
    var scrolledPast = r.bottom < 0;
    var offscreen = r.bottom < 0 || r.top > vh;
    var mobile = window.innerWidth < 750;
    var finalVisible = false;
    if (finalSec) { var f = finalSec.getBoundingClientRect(); finalVisible = f.top < vh * 0.85 && f.bottom > 0; }
    var show = (mobile ? offscreen : scrolledPast) && !finalVisible;
    if (sticky.getAttribute("data-show") !== String(show)) {
      sticky.setAttribute("data-show", String(show));
      sticky.setAttribute("aria-hidden", String(!show));
    }
  }

  /* =================== floor demo =================== */
  var floor = $("[data-tkd-floor]");
  var surface = floor && floor.querySelector("[data-tkd-floor-surface]");
  var dog = floor && floor.querySelector("[data-tkd-floor-dog]");
  var caption = floor && floor.querySelector("[data-tkd-floor-caption]");
  var sag = 0, raf = null, demoDone = reduceMotion;
  function drawSag(s) {
    if (!surface || !dog) return;
    surface.setAttribute("d", "M116 186 Q 258 " + (186 + s * 2).toFixed(1) + " 400 186 L 532 186 L 532 70");
    dog.setAttribute("transform", "translate(262 " + (186 + s * 0.98).toFixed(1) + ") rotate(" + (s * 0.14).toFixed(2) + ")");
  }
  function animateSag(target) {
    if (raf) cancelAnimationFrame(raf);
    if (reduceMotion) { sag = target; drawSag(sag); return; }
    var from = sag, start = performance.now(), dur = 900;
    (function step(now) {
      var t = clamp((now - start) / dur, 0, 1);
      var e = target > from ? 1 + 2.4 * Math.pow(t - 1, 3) + 1.4 * Math.pow(t - 1, 2) : 1 - Math.pow(1 - t, 3);
      sag = from + (target - from) * e;
      drawSag(sag);
      if (t < 1) raf = requestAnimationFrame(step);
    })(start);
  }
  function setMode(mode, user) {
    if (!floor) return;
    floor.setAttribute("data-mode", mode);
    $$("[data-tkd-floor-tab]", floor).forEach(function (t) { t.setAttribute("aria-selected", String(t.getAttribute("data-tkd-floor-tab") === mode)); });
    if (caption) caption.textContent = mode === "soft" ? "Soft hammock: the fabric dips into the gap and they slide." : "Hard bottom: the floor holds flat, even when they stand.";
    animateSag(mode === "soft" ? 72 : 0);
    if (user) emit("tk9_dtc_floor", { tk9_mode: mode });
  }
  if (floor) {
    drawSag(0);
    $$("[data-tkd-floor-tab]", floor).forEach(function (t) {
      t.addEventListener("click", function () { demoDone = true; setMode(t.getAttribute("data-tkd-floor-tab"), true); });
    });
    if (!demoDone && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || demoDone) return;
        demoDone = true;
        io.disconnect();
        setMode("soft");
        setTimeout(function () { setMode("hard"); }, 1600);
      }, { threshold: 0.5 });
      io.observe(floor);
    }
  }

  /* =================== video players (the motion graphic film, a creator's video) =================== */
  // Each loads only when it is watched, plays muted while in view, pauses when scrolled away, and has sound and
  // play/pause buttons. Turning sound on in one player mutes the others.
  var films = $$("[data-tkd-film]"), filmApi = [];
  films.forEach(function (film) {
    var fv = $("[data-tkd-film-video]", film), fSound = $("[data-tkd-film-sound]", film), fToggle = $("[data-tkd-film-toggle]", film);
    if (!fv) return;
    var name = film.getAttribute("data-tkd-film") || "film";
    var fLoaded = false, fWanted = !lean, fSeen = false;
    var filmState = function () {
      film.setAttribute("data-state", fv.paused ? "paused" : "playing");
      if (fToggle) fToggle.setAttribute("aria-label", fv.paused ? "Play video" : "Pause video");
    };
    var soundLabel = function () {
      if (!fSound) return;
      fSound.setAttribute("aria-pressed", String(!fv.muted));
      fSound.textContent = fv.muted ? "Tap for sound" : "Sound on";
    };
    var filmPlay = function () {
      if (!fLoaded) { fv.src = fv.getAttribute("data-src"); fLoaded = true; }
      var p = fv.play();
      if (p && typeof p.catch === "function") p.catch(filmState);
    };
    filmApi.push({ el: film, mute: function () { fv.muted = true; soundLabel(); } });
    fv.addEventListener("playing", filmState);
    fv.addEventListener("pause", filmState);
    if (fToggle) fToggle.addEventListener("click", function () {
      if (fv.paused) { fWanted = true; filmPlay(); } else { fWanted = false; fv.pause(); }
      emit("tk9_dtc_film", { tk9_film: name, tk9_on: fWanted });
    });
    if (fSound) fSound.addEventListener("click", function () {
      fv.muted = !fv.muted;
      if (!fv.muted) {
        filmApi.forEach(function (o) { if (o.el !== film) o.mute(); });
        fWanted = true; try { fv.currentTime = 0; } catch (e) { /* not loaded yet */ } filmPlay();
      }
      soundLabel();
      emit("tk9_dtc_film_sound", { tk9_film: name, tk9_on: !fv.muted });
    });
    if ("IntersectionObserver" in window) {
      // poster arrives a little before the section does; the file itself only when it is watched
      var filmNear = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        filmNear.disconnect();
        if (!fv.getAttribute("poster")) fv.setAttribute("poster", fv.getAttribute("data-poster") || "");
      }, { rootMargin: "500px 0px" });
      filmNear.observe(film);
      new IntersectionObserver(function (entries) {
        fSeen = entries[0].isIntersecting;
        if (fSeen && fWanted) filmPlay();
        else if (!fSeen && fLoaded) fv.pause();
      }, { threshold: 0.4 }).observe(film);
    } else if (fv.getAttribute("data-poster")) fv.setAttribute("poster", fv.getAttribute("data-poster"));
    filmState();
  });

  /* =================== two-state mechanism demo (tabs swap a data-mode; the drawing is CSS) =================== */
  var pull = $("[data-tkd-pull]");
  if (pull) {
    var pullCap = $("[data-tkd-pull-caption]", pull), pullDone = reduceMotion;
    var pullModes = $$("[data-tkd-pull-tab]", pull).map(function (t) { return t.getAttribute("data-tkd-pull-tab"); });
    var setPull = function (mode, user) {
      pull.setAttribute("data-mode", mode);
      $$("[data-tkd-pull-tab]", pull).forEach(function (t) { t.setAttribute("aria-selected", String(t.getAttribute("data-tkd-pull-tab") === mode)); });
      if (pullCap) pullCap.textContent = pull.getAttribute("data-cap-" + mode) || "";
      if (user) emit("tk9_dtc_demo", { tk9_mode: mode });
    };
    $$("[data-tkd-pull-tab]", pull).forEach(function (t) {
      t.addEventListener("click", function () { pullDone = true; setPull(t.getAttribute("data-tkd-pull-tab"), true); });
    });
    if (!pullDone && pullModes.length > 1 && "IntersectionObserver" in window) {
      var pullIO = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || pullDone) return;
        pullDone = true;
        pullIO.disconnect();
        setPull(pullModes[0]);
        setTimeout(function () { setPull(pullModes[pullModes.length - 1]); }, 1900);
      }, { threshold: 0.5 });
      pullIO.observe(pull);
    }
  }

  /* =================== brand world: the pattern and small objects load after the page has, never before =================== */
  if (root.classList.contains("tkd--brand")) {
    var deco = function () { setTimeout(function () { root.classList.add("is-deco"); }, 400); };
    if (document.readyState === "complete") deco(); else window.addEventListener("load", deco);
  }

  /* =================== gallery tiles with a short clip: load and play only while on screen =================== */
  var tileVideos = $$("[data-tkd-tile-video]");
  if (tileVideos.length && !reduceMotion && "IntersectionObserver" in window && !(navigator.connection && navigator.connection.saveData)) {
    var tileIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (!v.getAttribute("src")) { v.src = v.getAttribute("data-src"); v.addEventListener("playing", function () { v.setAttribute("data-playing", "true"); }); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (v.getAttribute("src")) v.pause();
      });
    }, { threshold: 0.6 });
    tileVideos.forEach(function (v) { tileIO.observe(v); });
  }

  /* =================== motion: reveals, counters, rotating proof =================== */
  function countUp(el) {
    var end = parseFloat(el.getAttribute("data-tkd-count")), dec = Number(el.getAttribute("data-decimals") || 0);
    if (!isFinite(end)) return;
    var fmt = function (n) { return n.toLocaleString("en-US", { minimumFractionDigits: dec, maximumFractionDigits: dec }); };
    var t0 = performance.now(), dur = 1300;
    (function step(now) {
      var t = clamp((now - t0) / dur, 0, 1), e = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(end * e);
      if (t < 1) requestAnimationFrame(step); else el.textContent = fmt(end);
    })(t0);
  }
  if (!reduceMotion && "IntersectionObserver" in window) {
    root.classList.add("is-motion");
    var rvIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add("is-in");
        rvIO.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.1 });
    $$("[data-rv]").forEach(function (n) { rvIO.observe(n); });
    var countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        countIO.unobserve(en.target);
        countUp(en.target);
      });
    }, { threshold: 0.6 });
    $$("[data-tkd-count]").forEach(function (n) { countIO.observe(n); });
    // never leave content hidden if an observer misfires
    setTimeout(function () {
      $$("[data-rv]:not(.is-in)").forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) n.classList.add("is-in");
      });
    }, 2500);
  }
  var proofItems = $$("[data-tkd-proof] li");
  if (proofItems.length > 1 && !reduceMotion) {
    var proofIdx = 0;
    setInterval(function () {
      if (document.hidden) return;
      proofItems[proofIdx].classList.remove("is-on");
      proofIdx = (proofIdx + 1) % proofItems.length;
      proofItems[proofIdx].classList.add("is-on");
    }, 3800);
  }

  /* =================== anatomy hotspots =================== */
  var anat = $("[data-tkd-anat]");
  if (anat) {
    var spots = $$("[data-tkd-spot]", anat), spotItems = $$("[data-tkd-spot-item]", anat), spotTimer = null, spotIdx = 0;
    var setSpot = function (i, user) {
      spotIdx = i;
      spots.forEach(function (b) { b.setAttribute("aria-pressed", String(Number(b.getAttribute("data-tkd-spot")) === i)); });
      spotItems.forEach(function (b) { b.setAttribute("aria-pressed", String(Number(b.getAttribute("data-tkd-spot-item")) === i)); });
      if (user) { clearInterval(spotTimer); spotTimer = null; emit("tk9_dtc_anatomy", { tk9_spot: i }); }
    };
    spots.forEach(function (b) { b.addEventListener("click", function () { setSpot(Number(b.getAttribute("data-tkd-spot")), true); }); });
    spotItems.forEach(function (b) { b.addEventListener("click", function () { setSpot(Number(b.getAttribute("data-tkd-spot-item")), true); }); });
    // tour the features once the module is on screen, until the shopper takes over
    if (!reduceMotion && "IntersectionObserver" in window && spots.length > 1) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (!spotTimer) spotTimer = setInterval(function () { if (!document.hidden) setSpot((spotIdx + 1) % spots.length, false); }, 2600);
        } else if (spotTimer) { clearInterval(spotTimer); spotTimer = null; }
      }, { threshold: 0.35 }).observe(anat);
    }
  }

  /* =================== customer video rail =================== */
  var clips = $$("[data-tkd-clip]");
  function clipPoster(v) {
    var p = v.getAttribute("data-poster");
    if (p && !v.getAttribute("poster")) v.setAttribute("poster", p);
  }
  function playClip(v) {
    clipPoster(v);
    if (!v.getAttribute("src")) v.src = v.getAttribute("data-src");
    v.muted = true;
    var p = v.play();
    if (p && typeof p.catch === "function") p.catch(function () {});
  }
  clips.forEach(function (v) {
    var card = v.closest(".tkd-clip");
    v.addEventListener("playing", function () { if (card) card.setAttribute("data-playing", "true"); });
    v.addEventListener("pause", function () { if (card) card.setAttribute("data-playing", "false"); });
    if (card) card.addEventListener("click", function () {
      if (v.paused) { v.setAttribute("data-user", "play"); playClip(v); emit("tk9_dtc_clip", { tk9_on: true }); }
      else { v.setAttribute("data-user", "pause"); v.pause(); }
    });
  });
  if (clips.length && "IntersectionObserver" in window) {
    var clipIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.55) {
          if (!lean && v.getAttribute("data-user") !== "pause") playClip(v);
        } else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.55] });
    clips.forEach(function (v) { clipIO.observe(v); });
    // thumbnails load only when the wall is getting close, so they never compete with the first screen
    var posterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { clipPoster(en.target); posterIO.unobserve(en.target); } });
    }, { rootMargin: "900px 0px" });
    clips.forEach(function (v) { posterIO.observe(v); });
  } else {
    clips.forEach(clipPoster);
  }

  /* =================== desktop: the photo wall stays in view beside the longer buy column =================== */
  // The buy column (options, receipt, details) is taller than the photo wall. The wall is sticky; when it is taller
  // than the window it pins by its bottom edge, so there is never an empty column beside the buy box.
  var galleryEl = $(".tkd-gallery");
  function pinGallery() {
    if (!galleryEl) return;
    if (window.innerWidth < 990) { galleryEl.style.removeProperty("--tkd-gal-top"); return; }
    galleryEl.style.setProperty("--tkd-gal-top", Math.min(16, window.innerHeight - galleryEl.offsetHeight - 16) + "px");
  }
  pinGallery();
  window.addEventListener("resize", pinGallery);
  window.addEventListener("load", pinGallery);

  /* =================== scroll loop =================== */
  var ticking = false;
  function onScroll() { ticking = false; updateSticky(); }
  window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();

  emit("tk9_dtc_view", { tk9_product: root.getAttribute("data-tkd-product") || "" });
})();
